(function() {
    'use strict';

    angular.module('app.compob2b.core', [
        'ngResource',
        'angucomplete-alt'
    ]);

})();

(function () {
    'use strict';
    
    angular
        .module('app.compob2b.directives',[]);
})();
(function() {
    'use strict';

    angular.module('app.compob2b', [
         
        'app.compob2b.core',
        'app.compob2b.directives',
        'ui.bootstrap',
        'mwl.confirm',
        'slickCarousel'
    ]);


})();


(function() {
    'use strict';
angular
    .module('app.compob2b.core')
    .run(runBlock);
  /* @ngInject */
  runBlock.$inject = ['CompoBasket','Store'];

  function runBlock(CompoBasket,Store) {

      Store.getData().then(function(data){ Store.data = data});
      CompoBasket.loadStats().then(function(data){ CompoBasket.stats = data});

  }
  
})();
(function() {
    'use strict';

    angular.module('app', [
        'app.compob2b'
    ]);
})();


(function () {
    'use strict';

    angular
        .module('app.compob2b')
        .config(config);

    config.$inject = ['$locationProvider'];
    /* @ngInject */
    function config($locationProvider) {
        $locationProvider.html5Mode(false);
    }
})();
(function () {
    'use strict';

    angular
        .module('app.compob2b')
        .config(config);

    config.$inject = ['$uibTooltipProvider'];
    /* @ngInject */
    function config($uibTooltipProvider) {
        $uibTooltipProvider.setTriggers({
            'show': 'hide'
        });
    }
})();
(function () {
    'use strict';

    angular
        .module('app.compob2b')
        .controller('Account', Account);

    Account.$inject = ['CompoApi','$timeout'];

    /* @ngInject */
    function Account(CompoApi,$timeout)
    {
        /* jshint validthis: true */
        var vm = this,
            Account = CompoApi.getSource();

            vm.changeType = changeType;
            vm.submit = submit;

            vm.alert = {
                show : false,
                class   : 'mstyle-02',

            };


        function changeType(type)
        {
            if(type === 'user')
            {

                vm.user.newpassword = '';
                vm.user.oldpassword = '';
                vm.user.repeatpassword = '';
                vm.formtype = 'user';

            }
            else if(type === 'password')
            {
                vm.formtype = 'password';

            }
        }


        function submit(form)
        {
            if ( form.$valid ) {
                save();
            }
            else
            {



            }
        }

        // Save user data
        function save()
        {

            var params = {
                method: 'accountUpdate',
                id: vm.user.id,
                user: vm.user
            };

            Account.put(params).$promise.then(function(data) {
                vm.alert.show = true;
                vm.alert.text = data.msg;

                if(data.error === true)
                {
                    vm.alert.class = 'mstyle-01';
                }
                else if(data.error === false)
                {

                    vm.alert.class = 'mstyle-02';
                }

                $timeout(function() {
                    vm.alert.show = false;
                }, 1700);
            });
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.compob2b')
        .controller('Act', Act);

    Act.$inject = ['$uibModalInstance', 'CompoApi', 'Store', '$timeout', 'acts'];

    /* @ngInject */
    function Act($uibModalInstance, CompoApi, Store, $timeout, acts) {
        var vm = this,
            startDate = new Date,
            endDate = new Date(),
            Act = CompoApi.getFilter();

        startDate.setMonth(startDate.getMonth() - 1);

        var ddStart = startDate.getDate();
        if (ddStart < 10) ddStart = '0' + ddStart;

        var mmStart = startDate.getMonth() + 1;
        if (mmStart < 10) mmStart = '0' + mmStart;

        var ddEnd = endDate.getDate();
        if (ddEnd < 10) ddEnd = '0' + ddEnd;

        var mmEnd = endDate.getMonth() + 1;
        if (mmEnd < 10) mmEnd = '0' + mmEnd;

        vm.preloader = false;
        vm.contracts = Store.data.contracts;
        vm.contragents = Store.data.contragents;
        vm.act = {
            contract_id: Object.keys(vm.contracts)[0],
            contragent_id: vm.contragents[0].id,
            startdate: ddStart + '.' + mmStart + '.' + startDate.getFullYear(),
            enddate: ddEnd + '.' + mmEnd + '.' + endDate.getFullYear()
        };

        vm.save = save;

        function save() {
            var start = vm.act.startdate.split('.');
            var end = vm.act.enddate.split('.');
            var startDate = new Date(start[2], (start[1] - 1), start[0]);
            var endDate = new Date(end[2], (end[1] - 1), end[0]);
            if (startDate >= endDate) {
                alert('Ошибка во временных периодах: дата начала периода больше или равна дате конца периода');
                return false;
            }
            vm.preloader = true;
            Act.post({method: 'act', act: vm.act}).$promise.then(function (response) {
                editValue(response);
                vm.preloader = false;
                $uibModalInstance.close();
            });
        }

        function editValue(data) {
            var newvalue = true;

            for (var i in acts) {
                if (acts[i].id == data.id) {
                    newvalue = false;
                    acts[i] = data;
                    break;
                }
            }

            if (newvalue) {
                acts.push(data);
            }
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.compob2b')
        .controller('Acts', Acts);

    Acts.$inject = ['CompoApi', '$uibModal', '$interval'];

    /* @ngInject */
    function Acts(CompoApi, $uibModal, $interval) {
        /* jshint validthis: true */
        var vm = this,
            startDate = new Date,
            endDate = new Date,
            paginatorStarted = false,
            Acts = CompoApi.getFilter();

        startDate.setMonth(startDate.getMonth() - 12);

        var ddStart = startDate.getDate();
        if (ddStart < 10) ddStart = '0' + ddStart;

        var mmStart = startDate.getMonth() + 1;
        if (mmStart < 10) mmStart = '0' + mmStart;

        var ddEnd = endDate.getDate();
        if (ddEnd < 10) ddEnd = '0' + ddEnd;

        var mmEnd = endDate.getMonth() + 1;
        if (mmEnd < 10) mmEnd = '0' + mmEnd;

        vm.count = 0;
        vm.contracts = [];
        vm.contragents = [];
        vm.goods = [];
        vm.isOpenDetail = [];
        vm.isOpenConsist = [];
        vm.pagination = [];
        vm.perpage = '20';
        vm.preloader = false;
        vm.filter = {
            method: 'getActs',
            contract: '0',
            contragent: '0',
            startDate: ddStart + '.' + mmStart + '.' + startDate.getFullYear(),
            endDate: ddEnd + '.' + mmEnd + '.' + endDate.getFullYear(),
            page: 1,
            perpage: vm.perpage
        };

        vm.run = run;
        vm.actModal = actModal;
        vm.paginate = paginate;

        run();
        activate();

        function activate() {
            $interval(function () {
                run();
            }, 10000);
        }

        function run() {
            //vm.preloader = true;
            getActs().then(function (response) {
                vm.acts = response.acts;
                vm.contracts = response.contracts;
                vm.contragents = response.contragents;
                vm.count = response.count;
                vm.pagination = response.pagination;
                //vm.preloader = false;
            });
        }

        function getActs() {
            return Acts.post(vm.filter).$promise;
        }

        function actModal() {
            $uibModal.open({
                animation: false,
                templateUrl: '/tpl/act_form.html',
                controller: 'Act',
                controllerAs: 'vm',
                resolve: {
                    acts: function () {
                        return vm.acts
                    }
                }
            });
        }

        function paginate(page) {
            vm.filter.page = page;

            if (vm.filter.page > 1) {
                paginatorStarted = true;
            }

            if (paginatorStarted) {
                vm.activate();
            }
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.compob2b')
        .controller('AddressModal', AddressModal);

    AddressModal.$inject = ['$uibModalInstance','$timeout','addresses','address'];

    /* @ngInject */
    function AddressModal($uibModalInstance, $timeout, addresses, address) {
        var vm = this;

        vm.address = address;
        vm.alert = {
            show : false,
            class   : 'color-green',
            text    : 'Данные сохранены'
        };

        vm.remove = remove;
        vm.save = save;

        function remove() {
            vm.address.$delete({id: vm.address.id}).then(function() {
                addresses.splice(addresses.indexOf(address), 1);
            });
            $uibModalInstance.close();
        }

        function save()
        {
            vm.address.$save({id: vm.address.id}).then(function(data) {
                $uibModalInstance.close();
            });
        }

        function editValue(data)
        {
            var newvalue = true;

            for (var i in addresses) {
                if (addresses[i].id == data.id) {
                    newvalue = false;
                    addresses[i] = data;
                    break;
                }
            }

            if (newvalue) {
                addresses.push(data);
            }
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.compob2b')
        .controller('Address', Address);

    Address.$inject = ['CompoApi','$uibModal'];

    /* @ngInject */
    function Address(CompoApi,$uibModal)
    {
        /* jshint validthis: true */
        var vm = this,
            Address = CompoApi.getAddress();

        vm.address = '0';
        vm.addresses = [];

        vm.alert = {
            show : false,
            class   : 'color-green',
            text    : 'Данные сохранены'
        };

        vm.deleteAddressModal = deleteAddressModal;
        vm.editAddressModal   = editAddressModal;

        activate();

        function activate() {
            getAddresses().then(function(addresses) {
                vm.addresses = addresses;
            });
        }

        function getAddresses()
        {
            return Address.query().$promise;
        }

        function editAddressModal(address)
        {
            $uibModal
                .open({
                    animation: false,
                    templateUrl: '/tpl/address_form.html',
                    controller: 'AddressModal',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        addresses: function() { return vm.addresses },
                        address: function() { return address ? angular.copy(address) : new Address; }
                    }
                })
                .closed.then(function () {
                    location.reload();
                });
        }

        function deleteAddressModal(address) {
            $uibModal
                .open({
                    animation: false,
                    template: '<a class="m-close" data-dismiss="modal" href="#" ng-click="$close()">Закрыть</a>' +
                    '<div class="modal-header">' +
                    '<h4 class="modal-title">Удалить адрес?</h4></div>'+
                    '<div class="modal-body">{{ vm.address.full_address }}</div>'+
                    '<div class="modal-footer">'+
                    '<button class="btn btn-danger" ng-click="vm.remove()">Удалить</button>'+
                    '<button class="btn" ng-click="$close()">Отмена</button></div>',
                    controller: 'AddressModal',
                    controllerAs: 'vm',
                    resolve: {
                        addresses: function() { return vm.addresses },
                        address:   function() { return address; }
                    }
                })
                .closed.then(function () {
                    location.reload();
                });
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.compob2b')
        .controller('BasketTableController', BasketTableController);
    BasketTableController.$inject = ['CompoApi', 'CompoBasket', '$uibModal','$window','$interval'];
    /* @ngInject */
    function BasketTableController(CompoApi, CompoBasket, $uibModal,$window,$interval) {
        var v = this;
        v.basket = CompoBasket;
        v.quantity = quantity;
        v.productsCountSet = [];
        v.clearBasket = clearBasket;
        v.deleteOneProduct = deleteOneProduct;
        v.deleteFromBasket = deleteFromBasket;
        v.changeQuantity = changeQuantity;
        v.recount = recount;
        v.saveDraft = saveDraft;
        v.checkPromo = checkPromo;
        v.promocode = '';
        v.productSet = [];
        v.locationPath = $window.location.pathname;
        v.confirmTitle = 'Подтвердите действие';
        v.clearBasketMessage = 'Вы действиетельно хотите очистить корзину?';
        v.deleteBasketMessage = 'Удалить отмеченные товары?';
        v.confirmText = 'Да';
        v.cancelText = 'Нет';
        v.promoText = '';
        v.formatDiscountCondition = formatDiscountCondition;
        v.formatDiscountPrice = formatDiscountPrice;
        /*
         activate();

         function activate()
         {
             $interval(function() {
                 loadStats();
             },12000);
         }

         */

        function formatDiscountCondition(val, type, currency) {
            if (type === 'sum') {
                return [
                    Number(val).format(2,3),
                    currency ? currency : 'RUB',
                    '+'
                ].join(' ');
            } else {
                return [
                    Number(val).format(0,3),
                    'ШТ',
                    '+'
                ].join(' ');
            }
        }

        function formatDiscountPrice(val, currency) {
            return [
                Number(val).format(2,3),
                currency ? currency : 'RUB'
            ].join(' ')
        }

        Number.prototype.format = function(n, x) {
            var re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\.' : '$') + ')';
            return this.toFixed(Math.max(0, ~~n)).replace(new RegExp(re, 'g'), '$& ');
        };

        function checkPromo() {
            if (v.promocode === '') {
                v.promoText = 'Вы не ввели промокод';
            } else {
                CompoBasket.checkPromo(v.promocode).then(function (data) {
                    if(data.result === true) {
                        v.promoText = 'Промокод применен';
                    } else
                    {
                        v.promoText = 'Введен недействительный промокод';
                    }
                    loadStats();
                }).catch(function (data, status) {
                    console.log(data + '-' + status);
                });
            }
        }

        function loadStats() {
            CompoBasket.loadStats().then(function (data) {
                CompoBasket.stats = data;
            });
        }

        function saveDraft() {
            $uibModal.open({
                animation: false,
                controller: 'DraftsModal',
                controllerAs: 'vm',
                templateUrl: '/tpl/draft_form.html',
                resolve: {
                    draftName: function() {
                        var date = new Date();
                        return 'Корзина от ' + date.getDate() + '/' + (date.getMonth()+1) + '/' + date.getFullYear() + ' ' + date.getHours() + ':' + date.getMinutes() + ':' + date.getSeconds();
                    }
                }
            });
        }

        function deleteOneProduct(id, wms, region, type) {
            CompoBasket.processBasket(id, 0, wms, region, type).then(function () {
                loadStats();
            }).catch(function (data, status) {
                console.log(data + '-' + status);
            });
        }

        function clearBasket() {
            CompoBasket.clearBasket().then(function () {
                loadStats();

            }).catch(function (data, status) {
                console.log(data + '-' + status);
            });
        }

        function recount(product) {
            if (undefined === v.productsCountSet[product.id][product.wms]) {
                v.productsCountSet[product.id][product.wms] = parseInt(product['quantity'],10);
            }

            if (null === v.productsCountSet[product.id][product.wms]) {
                v.productsCountSet[product.id][product.wms] = 0;
            }

            CompoBasket.processBasket(product.id, v.productsCountSet[product.id][product.wms],product.wms,'products').then(function(data) {
                loadStats();

            }).catch(function (data, status) {
                console.log(data + '-' + status);
            });
        }

        function changeQuantity(qnt, id, wms, max_qnt) {
            qnt = parseInt(qnt);
            max_qnt = parseInt(max_qnt);
            if (isNaN(parseInt(v.productsCountSet[id][wms]))) {
                v.productsCountSet[id][wms] = '1';
                qnt = 1;
            }
            if (qnt > 0 && qnt <= max_qnt) {

                v.productsCountSet[id][wms] = qnt;

                CompoBasket.processBasketUpdate(id, qnt, wms, 'products').then(function (data) {
                    loadStats();

                }).catch(function (data, status) {
                    console.log(data + '-' + status);
                });
            } else if (qnt > max_qnt) {
                v.productsCountSet[id][wms] = max_qnt;
            }
        }

        function quantity(qnt, id, wms, max_qnt) {
            var oldQnt = parseInt(v.productsCountSet[id][wms]);
            qnt = parseInt(qnt);
            max_qnt = parseInt(max_qnt);

            if (isNaN(parseInt(v.productsCountSet[id][wms]))) v.productsCountSet[id][wms] = '1';

            if ((oldQnt += qnt) > 0 && (oldQnt) <= max_qnt) {
                v.productsCountSet[id][wms] = parseInt(v.productsCountSet[id][wms]) + qnt;

                CompoBasket.processBasket(id, qnt, wms, 'products').then(function (data) {
                    loadStats();

                }).catch(function (data, status) {
                    console.log(data + '-' + status);
                });
            }
        }

        function deleteFromBasket() {
            CompoBasket.processProductSet().then(function () {
                v.productSet = [];
                loadStats();
            }).catch(function (data, status) {
                console.log(data + '-' + status);
            });
        }
    }
})();

(function()
{
    'use strict';
/** @ngInject */
    angular
        .module('app.compob2b')
        .controller('BasketModalController', BasketModalController);
    BasketModalController.$inject = ['CompoApi', 'CompoBasket','id','contract','warehouses','region','$uibModal'];
    /* @ngInject */ 
    function BasketModalController(CompoApi, CompoBasket, id, contract, warehouses, region,uibModal)
    {
        var v = this;
       
        
    }
})();
(function () {
    'use strict';

    angular
        .module('app.compob2b')
        .controller('Callback', Callback);

    Callback.$inject = ['CompoApi','$timeout'];

    /* @ngInject */
    function Callback(CompoApi,$timeout) {
        var vm = this,
            Resourse = CompoApi.getSource();

        vm.user = {
            phone : '',
            firstname: ''
        };
        vm.message = '';
        vm.sent = false;
        vm.fail = false;

        vm.send = send;

        function send()
        {
            sendForm().then(function (response) {
                if ('success' == response.status) {
                    vm.sent = true;
                } else {
                    vm.fail = true;
                    vm.message = response.message;
                    $timeout(function() {
                        vm.fail = false;
                        vm.message = '';
                    }, 2000);
                }
            });

        }

        function sendForm() {
            return Resourse.put({method:'callback',data:vm.user}).$promise;
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.compob2b')
        .controller('Chat', Chat);

    Chat.$inject = ['CompoApi', '$interval'];

    /* @ngInject */
    function Chat(CompoApi, interval) {
        /* jshint validthis: true */
        var vm = this,
            ChatServ = CompoApi.getSource();

        vm.filter = {
            method: 'chat',
            action: 'messages'
        };
        vm.message ='';
        vm.messages = {};
        vm.paneConfig = {
            stickToBottom: true,
            autoReinitialise: true,
            animateScroll: true,
            mouseWheelSpeed: 50
        };

        vm.getMessageClass = getMessageClass;
        vm.sendMessage = sendMessage;

        run();
        activate();

        function activate()
        {
            interval(function() {
                run();
            },5000);
        }

        function run()
        {
            getMessages().then(function(response) {
                setMessages(response.messages);
            });
        }

        function setMessages(messages)
        {
            angular.forEach(messages, function(value, key) {
                
                if (!vm.messages[key]) {
                    vm.messages[key] = value;
                }
            });
         
        }

        function getMessages()
        {
            return ChatServ.put({method:'chat',action:'messages'}).$promise;
        }

        function getMessageClass(message)
        {
            if (message) {
                var from = message['from_whom'].split(':');
                return 'cid' == from[0] ? 'sms-item-user' : 'sms-item-manager';
            }
        }

        function sendMessage()
        {
            ChatServ.put({method:'chat',action:'send',message:vm.message}).$promise.then(function(response) {
                vm.message = '';
                setMessages(response.messages);
            
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.compob2b')
        .controller('CompareController', CompareController);

    CompareController.$inject = ['CompoApi', 'CompoCompare', '$window'];

    /* @ngInject */
    function CompareController(CompoApi, CompoCompare, window) {
        var v = this,
            Product = CompoApi.getSource();
        v.info = CompoCompare;

        v.remove = remove;

        function remove(id) {


            var method = 'removeFromCompare';
            var params = {
                method: method,
                id: id
            };

            Product.put(params).$promise.then(function () {

                CompoCompare.reload().then(function (data) {

                    CompoCompare.stats = data;
                    window.location.reload();

                });

            });


        }

    }

})();

(function () {
    'use strict';

    angular
        .module('app.compob2b')
        .controller('Contragent', Contragent);

    Contragent.$inject = ['$uibModalInstance','$timeout','contragents','contragent'];

    /* @ngInject */
    function Contragent($uibModalInstance, $timeout, contragents, contragent)
    {
        var vm = this;

        vm.contragent = contragent;

        vm.alert = {
            show : false,
            class: '',
            text : ''
        };

        vm.remove = remove;
        vm.save = save;

        function remove()
        {
            vm.contragent.$delete({id: vm.contragent.id}).then(function() {
                contragents.splice(contragents.indexOf(contragent), 1);
            });
            $uibModalInstance.close();
        }

        function save()
        {
            vm.contragent.$save({id: vm.contragent.id}).then(function(response) {
                if ('success' == response.state) {
                    vm.alert.class = 'color-green';
                    vm.alert.text = 'Данные сохранены';
                    editValue(response);
                } else {
                    vm.alert.class = 'color-red';
                    vm.alert.text = 'Ошибка контрагент либо зарегистрирован либо не заполнены поля';
                }

                if (response.new) {
                    $uibModalInstance.close();
                } else {
                    vm.alert.show = true;
                    $timeout(function () {
                        vm.alert.show = false;
                    }, 3000);
                }
            });
        }

        function editValue(data)
        {
            var newvalue = true;

            for (var i in contragents) {
                if (contragents[i].id == data.id) {
                    newvalue = false;
                    contragents[i] = data;
                    break;
                }
            }

            if (newvalue) {
                contragents.push(data);
            }
        }

    }
})();
(function() {
    'use strict';

    angular
        .module('app.compob2b')
        .controller('Contragents', Contragents);

    Contragents.$inject = ['CompoApi', 'Store', '$uibModal'];

    /* @ngInject */
    function Contragents(CompoApi, Store, $uibModal) {
        /* jshint validthis: true */
        var vm = this,
            Contragent = CompoApi.getContragent();

        vm.preloader = {};
        vm.contragents = [];
        vm.store = Store;
        vm.contragentModal = contragentModal;

        activate();

        function activate() {
            getContragents().then(function(contragents) {
                vm.contragents = contragents;
            });
        }

        function getContragents()
        {
            return Contragent.query().$promise;
        }

        function contragentModal(contragent)
        {
            $uibModal.open({
                animation: false,
                templateUrl: '/tpl/contragent_form.html',
                controller: 'Contragent',
                controllerAs: 'vm',
                resolve: {
                    contragents: function() { return vm.contragents },
                    contragent: function() {
                        return contragent ? angular.copy(contragent) : new Contragent;
                    }
                }
            });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.compob2b')
        .controller('DraftsModal', DraftsModal);

    DraftsModal.$inject = ['CompoBasket','draftName'];

    /* @ngInject */
    function DraftsModal(CompoBasket, draftName) {
        var vm = this;
        vm.flag = false;
        vm.draftName = draftName;

        vm.save = save;

        function save()
        {
            if (vm.draftName.length) {
                CompoBasket.addToDraft(vm.draftName).then(function (data) {
                    vm.flag = true;
                }).catch(function (data, status) {
                    console.log(data + '-' + status);
                });
            }
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.compob2b')
        .controller('Drafts', Drafts);

    Drafts.$inject = ['CompoApi','CompoBasket','$uibModal'];

    /* @ngInject */
    function Drafts(CompoApi,CompoBasket,$uibModal) {
        /* jshint validthis: true */
        var vm = this,
            paginatorStarted = false,
            Drafts = CompoApi.getSource();
        vm.count = 0;
        vm.drafts = [];
        vm.isOpenDetail = [];
        vm.isOpenConsist = [];
        vm.pagination = [];
        vm.perpage = '10';
        vm.preloader = true;
        vm.filter = {
            method: 'drafts',
            page: 1,
            perpage: vm.perpage
        };

        vm.remove = remove;
        vm.repeat = repeat;
        vm.paginate = paginate;

        activate();

        function activate()
        {
            vm.preloader = true;
            getDrafts().then(function(response) {
                vm.drafts = response.drafts;
                vm.count = response.count;
                vm.pagination = response.pagination;
                vm.preloader = false;
            });
        }

        function remove(draft)
        {
            Drafts.put({method: 'drafts', id:draft.id, action:'remove'}).$promise.then(function() {
                activate();
            });
        }

        function repeat(draft)
        {
            Drafts.put({method: 'drafts', id: draft.id, action: 'repeat'}).$promise.then(function(response) {
                CompoBasket.loadStats().then(function (data) {
                    CompoBasket.stats = data
                });
                $uibModal.open({
                    animation: false,
                    template: '<a class="m-close" data-dismiss="modal" href="#" ng-click="$close()">Закрыть</a>' +
                    '<div class="modal-header">' +
                    '<h4 class="modal-title">Заказ добавлен в корзину</h4></div>'+
                    '<div class="modal-body">Добавлено артикулов - ' + response.count + ' шт.</div>' +
                    '<div class="modal-footer">'+
                    '<a href="/cart/" class="mbtn mbtn-blue">В корзину</a>' +
                    '<button class="btn" ng-click="$close()">Закрыть</button></div>'
                });
            });
        }

        function getDrafts()
        {
            return Drafts.get(vm.filter).$promise;
        }

        function paginate(page) {
            vm.filter.page = page;

            if (vm.filter.page > 1) {
                paginatorStarted = true;
            }

            if (paginatorStarted) {
                activate();
            }
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.compob2b')
        .controller('FavoritesController', FavoritesController);

    FavoritesController.$inject = ['CompoApi','CompoBasket','$uibModal'];

    /* @ngInject */
    function FavoritesController(CompoApi,CompoBasket,$uibModal) {
        /* jshint validthis: true */
        var vm = this,
            paginatorStarted = false,
            Favorites = CompoApi.getSource();

        vm.count = 0;
        vm.contract = 0;
        vm.productsCountSet = [];
        vm.goods = [];
        vm.pagination = [];
        vm.perpage = '20';
        vm.preloader = true;
        vm.filter = {
            method: 'favorites',
            page: 1,
            perpage: vm.perpage
        };

        vm.activate = activate;
        vm.addOneProduct = addOneProduct;
        vm.getProduct = getProduct;
        vm.paginate = paginate;
        vm.recount = recount;
        vm.remove = remove;

        activate();

        function activate()
        {
            vm.preloader = true;
            getGoods().then(function(response) {
                vm.goods = response.goods;
                vm.count = response.count;
                vm.contract = response.contract;
                vm.pagination = response.pagination;
                vm.preloader = false;

                CompoBasket.setContract(vm.contract);
            });
        }

        function getProduct(id)
        {
            var url = '/ajax/getproduct/?id=' + id;

            $uibModal.open({
                size: 'lg',
                templateUrl: url,
                windowClass: 'modal fade popup-product',
                controller: 'ProductController',
                bindToController: true,
                controllerAs: 'v',
                resolve: {
                    id: function() { return id; },
                    contract: function() { return vm.contract; }
                }
            });

        }

        function addOneProduct(id, qnt, wms)
        {

            if (0 === qnt) {
                alert('Укажите количество товара');
                return;
            }

            CompoBasket.addProduct(id, qnt, wms).then(function () {
                CompoBasket.loadStats().then(function (data) {
                    CompoBasket.stats = data
                });
                angular.element('#cartDone').modal();
            }).catch(function (data, status) {
                console.log(data + '-' + status);
            });
        }

        function remove(product) {
            var params = {
                method: 'unsetWish',
                id: product.id
            };
            Favorites.put(params).$promise.then(function(){
                activate();
            });
        }

        function recount(product)
        {
            if (undefined === vm.productsCountSet[product.id][product.wms_id]) {
                //alert('Для заказа доступно - ' + parseInt(product['quantity'],10) + ' шт.');
                alert('Не достаточно свободных остатков на складе');
                vm.productsCountSet[product.id][product.wms_id] = parseInt(product['quantity'],10);
            }

            if (null === vm.productsCountSet[product.id][product.wms_id]) {
                vm.productsCountSet[product.id][product.wms_id] = 0;
            }

        }

        function getGoods()
        {
            return Favorites.put(vm.filter).$promise;
        }

        function paginate(page) {
            vm.filter.page = page;

            if (vm.filter.page > 1) {
                paginatorStarted = true;
            }

            if (paginatorStarted) {
                vm.activate();
            }
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.compob2b')
        .controller('FilterController', FilterController);

    FilterController.$inject = ['CompoApi', 'CompoBasket', 'Store', '$uibModal','$location','$scope','$timeout'];
    /* @ngInject */
    function FilterController(CompoApi, CompoBasket, Store, $uibModal,$location,scope,$timeout) {
        var v = this,
            paginatorStarted = false,
            Filter = CompoApi.getFilter();
        v.prices = {
            'minprice': false,
            'maxprice': false,
            'pricemin': false,
            'pricemax': false
        };
        v.available = true;
        v.byprice = 0;
        v.filters = [];
        v.range = [];
        v.maxminprices = [];
        v.products = [];
        v.pagination = [];
        v.tags = [];
        v.allbrands = '0';
        v.catalogs = Store.getCatalog();
        v.catalog_tree = [];
        v.contract = '0';
        v.contracts = [];
        v.perpage = '20';
        v.origin = 'catalog';
        v.page = 1;
        v.productSet = [];
        v.productsCountSet = [];
        v.productsNeedSet = [];
        v.params = [];
        v.preloader = true;
        v.run = run;
        v.activate = activate;
        v.reset = reset;
        v.basket = CompoBasket;
        v.addOneProduct = addOneProduct;
        v.changeNeed = changeNeed;
        v.quantity = quantity;
        v.getProduct = getProduct;
        v.selectedAdditional = false;
        v.setProductOrigin = setProductOrigin;
        v.setCatalog = setCatalog;
        v.setContract = setContract;
        v.setFilter = setFilter;
        v.priceFilter = priceFilter;
        v.newFilter = newFilter;
        v.filterAvailible = filterAvailible;
        v.recount = recount;
        v.sort = sort;
        v.warehouse = 1;
        v.warehouses = {};
        v.regions2wms = [];
        v.region = '1';
        v.query = '';
        v.sorting = {
            field: 'header',
            sort: 'asc'
        };
        v.sortingFields = {
            articul: 'sorting',
            header: 'sorting_asc',
            price: 'sorting',
            price_rrc: 'sorting'
        };

        scope.$on('store:catalog:change', function () {
            v.catalogs = Store.getCatalog();
            v.setCatalog(v.catalogs);
        });

        init();

        function init() {
            Filter.post({method:'filterinit'}, function (response) {
                v.contracts = response.contracts;
                v.catalog_tree = response.catalog_tree;

                var contract = response.selectedContract;

                if(contract !== 0) {
                    v.contract = contract;
                } else {
                    v.contract = Object.keys(v.contracts)[0];
                }

                CompoBasket.setContract(v.contract);

                angular.forEach(response.warehouses, function(value, key) {
                    this[key] = {name: value.header, value: value.id};
                }, v.warehouses);
                v.warehouse = v.warehouses[0].value;

                v.run();
            });

        }

        function sort(field)
        {
            var sort = 'sorting';

            switch (v.sortingFields[field])
            {
                case 'sorting':
                    sort = 'asc';
                    break;
                case 'sorting_asc':
                    sort = 'desc';
                    break;
                case 'sorting_desc':
                    sort = 'asc';
                    break;
            }

            v.sortingFields[field] = 'sorting_' + sort;
            v.sorting.field = field;
            v.sorting.sort = sort;

            angular.forEach(v.sortingFields, function (value, key) {
                if (key != field) {
                    this[key] = 'sorting';
                }
            }, v.sortingFields);

            v.newFilter();
        }

        function setProductOrigin() {
            v.origin = v.selectedAdditional;
            v.page = 1;
            v.run();
        }

        function setCatalog(id) {
            v.filters = [];
            v.allbrands = '0';
            v.catalogs = id;
            v.newFilter();
        }

        function priceFilter() {
            v.byprice = 1;
            v.newFilter();
        }

        function newFilter() {
            v.page = 1;
            v.run();
            $location.search('page', 1);
        }

        function setFilter(key,val) {
            v.filters[key] = val;
            v.newFilter();
        }

        function run() {
            var params = {
                method: 'filter',
                origin: v.origin,
                available: v.available,
                brand: v.allbrands,
                catalog: v.catalogs,
                contract: v.contract,
                warehouse: v.warehouse,
                perpage: v.perpage,
                byprice : v.byprice,
                minprice: v.prices.pricemin,
                maxprice: v.prices.pricemax,
                filter: v.filters,
                search_range: v.range,
                page: v.page,
                query: v.query,
                sorting: v.sorting,
                tags: v.tags
            };
            v.preloader = true;
            Filter.post(params, function (response) {
                v.brands = response.brands.data;
                v.prices = response.prices;
                v.products = response.products;
                v.params = response.params;
                if (0 == v.range.length) {
                    angular.forEach(v.params.maxmin, function (value, key) {
                        this[key] = {from: value.minp, to: value.maxp};
                    }, v.range);
                }
                v.byprice = 0;
                v.preloader = false;
            });
        }

        function recount(product)
        {
            if (undefined === v.productsCountSet[product.id][product.wms_id]) {
                //alert('Для заказа доступно - ' + parseInt(product['quantity'],10) + ' шт.');
                alert('Не достаточно свободных остатков на складе');
                v.productsCountSet[product.id][product.wms_id] = parseInt(product['quantity'],10);
            }

            if (null === v.productsCountSet[product.id][product.wms_id]) {
                v.productsCountSet[product.id][product.wms_id] = 0;
            }

        }

        function changeNeed(product)
        {
            var method = v.productsNeedSet[product.id] ? 'unsetNeed' : 'setNeed';
            var params = {
                method: method,
                id: product.id
            };
            Filter.post(params);
        }

        function getProduct(id)
        {
            var url = '/ajax/getproduct/?id=' + id;

            $uibModal.open({
                size: 'lg',
                templateUrl: url,
                windowClass: 'modal fade popup-product',
                controller: 'ProductController',
                bindToController: true,
                controllerAs: 'v',
                resolve: {
                    id: function() { return id; },
                    contract: function() { return v.contract; }
                }
            });

        }

        function quantity(qnt, id)
        {

            var oldQnt = parseInt(v.productsCountSet[id]);
            qnt = parseInt(qnt);

            if (isNaN(parseInt(v.productsCountSet[id]))) v.productsCountSet[id] = '1';

            if ((oldQnt += qnt) > 0) {
                v.productsCountSet[id] = parseInt(v.productsCountSet[id]) + qnt;
            }
        }

        function addOneProduct(id, qnt, wms)
        {

            if (0 === qnt) {
                alert('Укажите количество товара');
                return;
            }

            CompoBasket.addProduct(id, qnt, wms).then(function () {
                CompoBasket.loadStats().then(function (data) {
                    CompoBasket.stats = data
                });
                angular.element('.product'+id).trigger('show');
                $timeout(function () {
                    angular.element('.product'+id).trigger('hide');
                }, 2500);
            }).catch(function (data, status) {
                console.log(data + '-' + status);
            });
        }

        function filterAvailible()
        {
            v.range = [];
            v.newFilter();
        }

        function reset()
        {
            v.query = '';
            v.allbrands = '0';
            v.selectedAdditional = false;
            v.origin = 'catalog';
            angular.forEach(v.filters, function (value, key) {
                v.filters[key] = '0';
            });
            v.newFilter();
        }

        function activate(page)
        {
            v.page = page;

            /*check pagination click*/
            if (v.page > 1) {
                paginatorStarted = true;
            }

            /*check pagination clicked we can do the ajax request else we don't need to do this*/
            if (paginatorStarted) {
                v.run();
            }
        }

        function setContract()
        {
            CompoBasket.setContract(v.contract);
            var params = {
                method: 'setContract',
                id: v.contract
            };

            Filter.post(params,function(response) {
                v.newFilter();
            });

        }

        function setRegion()
        {
            CompoBasket.setRegion(v.region);
            v.warehouses = {};
            angular.forEach(v.regions2wms[v.region], function(value, key) {
                this[key]={name:value.header, value: key, selected:true};
            },v.warehouses);

            v.newFilter();
        }

    }
})();
(function() {
    'use strict';

    angular
        .module('app.compob2b')
        .controller('HeaderBasketController', HeaderBasketController);

    HeaderBasketController.$inject = ['CompoBasket', 'CompoApi', '$uibModal', '$scope'];
    /* @ngInject */
    function HeaderBasketController(CompoBasket, CompoApi, $uibModal, $scope) {
        var v = this;
        v.basket = CompoBasket;
        v.contract = '';
        v.setContract = setContract;
        v.deleteOneProduct = deleteOneProduct;

        $scope.deliveryMethod = '0';
        $scope.deliveryPoint = '0';

        $scope.currentAddress = {id: '0', full_address: ''};
        $scope.addressesList = [
            {id: '0', full_address: ''},
            {id: '-1', full_address: 'Добавить новый...'},
        ];
        // v.addressChangeHandle = addressChangeHandle;
        // v.setAddresses = setAddresses;
        // v.getAddress = getAddress;


        $scope.getAddress = function () {
            return $scope.addressesList;
        };

        $scope.setAddresses = function () {
            CompoApi.getAddress().query().$promise.then(function (r) {
                if (r && r.length) {
                    $scope.currentAddress = r[r.length - 1].id;
                    $scope.addressesList = r;
                    $scope.addressesList.push({id: -1, full_address: 'Добавить новый...'})
                    $('.dataselect').selectmenu({
                        change: function () {
                            $(this).trigger('change');
                        }
                    });
                } else {
                    $scope.addressesList = [
                        {id: '0', full_address: ''},
                        {id: '-1', full_address: 'Добавить новый...'},
                    ];

                    $scope.currentAddress = '0';

                    $('.dataselect').selectmenu({
                        change: function () {
                            $(this).trigger('change');
                        }
                    });
                }
            });
        };

        $scope.addressChangeHandle = function (v) {
            if (v == '-1') {
                $scope.addressesList = [];
                var address = CompoApi.getAddress();
                $uibModal
                    .open({
                        animation: false,
                        templateUrl: '/tpl/address_form.html',
                        controller: 'AddressModal',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            addresses: function() { return $scope.addressesList },
                            address: function() { return new address }
                        }
                    })
                    .closed.then(function () {
                        $scope.setAddresses();
                        $('.dataselect').val($scope.currentAddress).selectmenu('refresh');
                    });
            }
        };

        $scope.deliveryMethodChangeHandle = function () {
            CompoBasket.changeDeliveryMethod($scope.deliveryMethod).then(function () {
                CompoBasket.loadStats().then(function (data) {
                    CompoBasket.stats = data
                });
            }).catch(function (data, status) {
                console.log(data + '-' + status);
            });
        };

        $scope.deliveryPointChangeHandle = function () {
            CompoBasket.changeDeliveryPoint($scope.deliveryPoint).then(function () {
                CompoBasket.loadStats().then(function (data) {
                    CompoBasket.stats = data
                });
            }).catch(function (data, status) {
                console.log(data + '-' + status);
            });
        };

        $scope.formatDiscountCondition = function (val, type, currency) {
            if (type === 'sum') {
                return [
                    Number(val).format(2,3),
                    currency ? currency : 'RUB',
                    '+'
                ].join(' ');
            } else {
                return [
                    Number(val).format(0,3),
                    'ШТ',
                    '+'
                ].join(' ');
            }
        }

        $scope.formatDiscountPrice = function (val, currency) {
            return [
                Number(val).format(2,3),
                currency ? currency : 'RUB'
            ].join(' ')
        }

        function setContract()
        {
            CompoBasket.changeContract(v.contract).then(function(){
                location.reload();
            });
        }

        function deleteOneProduct(id, wms, region, type) {

            CompoBasket.processBasket(id, 0, wms, region, type).then(function () {
                CompoBasket.loadStats().then(function (data) {
                    CompoBasket.stats = data
                });
            }).catch(function (data, status) {
                console.log(data + '-' + status);
            });

        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.compob2b')
        .controller('HeaderCompareController', HeaderCompareController);

    HeaderCompareController.$inject = ['CompoCompare'];

    /* @ngInject */
    function HeaderCompareController(CompoCompare) {
        var v = this;
        v.info = CompoCompare;


        init();

        function init() {
            CompoCompare.reload().then(function (data) {
                CompoCompare.stats = data;


            });
        }

    }

})();

(function () {
    'use strict';

    angular
        .module('app.compob2b')
        .controller('LoginController', LoginController);

    LoginController.$inject = ['$uibModal'];

    /* @ngInject */
    function LoginController(uibModal) {
        /* jshint validthis: true */
        var vm = this;

        vm.openRegistration = openRegistration;

        function openRegistration() {

            uibModal.open({
                animation: false,
                controller: 'RegistrationModal',
                controllerAs: 'vm',
                templateUrl: '/tpl/registration_form.html',
                backdrop: 'static',
                keyboard: false
            });

        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.compob2b')
        .controller('Main', Main);

    Main.$inject = ['CompoApi','Store','$uibModal'];

    /* @ngInject */
    function Main(CompoApi,Store,$uibModal) {
        /* jshint validthis: true */
        var vm = this,
            Api = CompoApi.getSource();
        vm.showCallback = showCallback;
        vm.hideNews = hideNews
        vm.store = Store;

        function hideNews(news) {
            Api.update({method:'hidetopnews',id:news.id});
        }

        function showCallback()
        {
            $uibModal.open({
                animation: false,
                templateUrl: '/ajax/callback',
                controller: 'Callback',
                controllerAs: 'vm'
            });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.compob2b')
        .controller('Manager', Manager);

    Manager.$inject = ['$uibModalInstance','$timeout','managers','manager','contracts','addresses'];

    /* @ngInject */
    function Manager($uibModalInstance, $timeout, managers, manager,contracts,addresses) {
        var vm = this;

        vm.manager = manager;
        vm.contracts = contracts;
        vm.addresses = addresses;

        vm.alert = {
            show : false,
            class: '',
            text : ''
        };

        vm.remove = remove;
        vm.save = save;

        activate();

        function activate()
        {
            if (typeof(vm.manager.type_id) == "undefined") {
                vm.manager.type_id = '2';
            }
        }

        function remove()
        {
            vm.manager.$delete({id: vm.manager.id}).then(function() {
                managers.splice(managers.indexOf(manager), 1);
            });
            $uibModalInstance.close();
        }

        function save()
        {
            vm.manager.$save({id: vm.manager.id}).then(function(response) {
                if ('success' == response.state) {
                    vm.alert.class = 'color-green';
                    vm.alert.text = 'Данные сохранены';
                    editValue(response);
                } else {
                    vm.alert.class = 'color-red';
                    vm.alert.text = 'Этот Email уже занят';
                }

                if (response.new) {
                    $uibModalInstance.close();
                } else {
                    vm.alert.show = true;
                    $timeout(function () {
                        vm.alert.show = false;
                    }, 3000);
                }
            });
        }

        function editValue(data)
        {
            var newvalue = true;

            for (var i in managers) {
                if (managers[i].id == data.id) {
                    newvalue = false;
                    managers[i] = data;
                    break;
                }
            }

            if (newvalue) {
                managers.push(data);
            }
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.compob2b')
        .controller('Managers', Managers);

    Managers.$inject = ['CompoApi', 'Store', '$uibModal'];

    /* @ngInject */
    function Managers(CompoApi, Store, $uibModal) {
        /* jshint validthis: true */
        var vm = this,
            Manager = CompoApi.getManager();

        vm.preloader = {};
        vm.managers = [];
        vm.store = Store;
        vm.activateManager = activateManager;
        vm.managerModal = managerModal;
        vm.pricePoliticsModal = pricePoliticsModal;

        activate();

        function activate() {
            getManagers().then(function(managers) {
                vm.managers = managers;
            });
        }

        function getManagers()
        {
            return Manager.query().$promise;
        }

        function activateManager(manager)
        {
            manager.enabled = ('0' == manager.enabled) ? '1' : '0';
            console.log(manager);
            vm.preloader[manager.id] = true;
            manager.$save({id: manager.id}).then(function(){
                vm.preloader[manager.id] = false;
            });
        }

        function pricePoliticsModal(manager)
        {
            $uibModal.open({
                animation: false,
                templateUrl: '/tpl/price_politics.html',
                controller: 'PricePolitics',
                controllerAs: 'vm',
                resolve: {
                    manager: function() { return manager; }
                }
            });
        }

        function managerModal(manager)
        {
            $uibModal.open({
                animation: false,
                templateUrl: '/tpl/manager_form.html',
                controller: 'Manager',
                controllerAs: 'vm',
                resolve: {
                    managers: function() { return vm.managers },
                    contracts: function() { return vm.store.data.contracts },
                    addresses: function() { return vm.store.data.addresses },
                    manager: function() {
                        return manager ? angular.copy(manager) : new Manager;
                    }
                }
            });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.compob2b')
        .controller('Orders', Orders);

    Orders.$inject = ['CompoApi','CompoBasket','$uibModal'];

    /* @ngInject */
    function Orders(CompoApi,CompoBasket,$uibModal) {
        /* jshint validthis: true */
        var vm = this,
            paginatorStarted = false,
            Orders = CompoApi.getOrders();
        vm.count = 0;
        vm.contracts =[];
        vm.orders = [];
        vm.isOpenDetail = [];
        vm.isOpenConsist = [];
        vm.pagination = [];
        vm.perpage = '10';
        vm.preloader = true;
        vm.filter = {
            contract: '0',
            customer: '0',
            dateselect: 'week',
            paid: '0',
            state: '0',
            page: 1,
            perpage: vm.perpage
        };
        vm.markers = {
            3: 'c-green',
            4: 'c-orange',
            10: 'c-blue'
        };
        vm.states = [];
        vm.customers = [];

        vm.activate = activate;
        vm.cancel = cancel;
        vm.repeat = repeat;
        vm.paginate = paginate;
        vm.cancelRequest = cancelRequest;
        vm.confirm = confirm;
        vm.edit = edit;
        vm.setProductDelete = setProductDelete;
        vm.changeQuantity = changeQuantity;
        vm.quantity = quantity;
        vm.saveOrder = saveOrder;

        vm.activate();

        function activate()
        {
            vm.preloader = true;
            getOrders().then(function(response) {
                vm.orders = response.orders;
                vm.states = response.states;
                vm.customers = response.customers;
                vm.contracts = response.contracts;
                vm.count = response.count;
                vm.pagination = response.pagination;
                vm.preloader = false;
            });
        }

        function cancel(order)
        {
            Orders.cancel({id:order.id,action:'cancel'}).$promise.then(function(response){
                vm.orders["'"+order.id+"'"]['state'] = response.state;
                vm.orders["'"+order.id+"'"]['status'] = response.status;
            });
        }

        function confirm(order)
        {
            Orders.confirm({id:order.id,action:'confirm'}).$promise.then(function(response){
                vm.orders["'"+order.id+"'"]['state'] = response.state;
                vm.orders["'"+order.id+"'"]['status'] = response.status;
            });
        }

        function saveOrder(order)
        {
            var products = {};
            vm.orders["'"+order.id+"'"]['editable_process'] = false;

            for (var i = vm.orders["'"+order.id+"'"]['products'].length - 1; i >= 0; i--) {
                var item = {};
                var product = vm.orders["'"+order.id+"'"]['products'][i];

                item.id = product.id;

                item.total = product.total = product.new_total;

                if (product.is_delete) {
                    item.is_delete = true;
                    vm.orders["'"+order.id+"'"]['products'].splice(i, 1);
                } else {
                    item.is_delete = false;
                }

                products[item.id] = item;
            }

            Orders.saveOrder({id:order.id, products: products, action:'saveOrder'}).$promise.then(function(response){
                vm.orders["'"+order.id+"'"]['state'] = response.state;
                vm.orders["'"+order.id+"'"]['status'] = response.status;
                vm.orders["'"+order.id+"'"]['total'] = response.total;
            });
        }

        function edit(order)
        {
            if (vm.orders["'"+order.id+"'"]['editable_process']) {
                vm.orders["'"+order.id+"'"]['editable_process'] = false;

                angular.forEach(vm.orders["'"+order.id+"'"]['products'], function(value, key) {
                    vm.orders["'"+order.id+"'"]['products'][key]['is_delete'] = false;
                    vm.orders["'"+order.id+"'"]['products'][key]['new_state'] = value['state'];
                    vm.orders["'"+order.id+"'"]['products'][key]['new_total'] = value['total'];
                });
            } else {
                vm.orders["'"+order.id+"'"]['editable_process'] = true;
                var products = {};

                for (var i = vm.orders["'"+order.id+"'"]['products'].length - 1; i >= 0; i--) {
                    var item = {};
                    var product = vm.orders["'"+order.id+"'"]['products'][i];

                    item.id = product.id;

                    item.total = product.total = product.new_total;

                    if (product.is_delete) {
                        item.is_delete = true;
                        vm.orders["'"+order.id+"'"]['products'].splice(i, 1);
                    } else {
                        item.is_delete = false;
                    }

                    products[item.id] = item;
                }

                Orders.saveOrder({id:order.id, products: products, action:'saveOrder'}).$promise.then(function(response){

                });
            }
        }

        function setProductDelete(order, product)
        {
            if (product['is_delete']) {
                product['new_state'] = '<span class="text-danger">На удаление</span>';
            } else {
                product['new_state'] = product['state'];
            }
        }

        function quantity(qnt, order, product) {
            var oldQnt = parseInt(product.new_total);
            qnt = parseInt(qnt);
            var max_qnt = parseInt(product.remains);

            if ((oldQnt += qnt) > 0 && (oldQnt) <= max_qnt) {
                product.new_total = parseInt(product.new_total) + qnt;
            }
        }

        function changeQuantity(order, product) {
            var qnt = parseInt(product.new_total);
            var max_qnt = parseInt(product.remains);

            if (qnt > max_qnt) {
                product.new_total = max_qnt;
            }

            if (!qnt || qnt < 1) {
                product.new_total = 1;
            }
        }

        function cancelRequest(order)
        {
            Orders.cancelRequest({id:order.id,action:'cancelRequest'}).$promise.then(function(response){
                vm.orders["'"+order.id+"'"]['state'] = response.state;
                vm.orders["'"+order.id+"'"]['status'] = response.status;

                $uibModal.open({
                    animation: false,
                    template: //'<a class="m-close" data-dismiss="modal" href="#" ng-click="$close()">Закрыть</a>' +
                        '<div class="modal-header">' +
                        '<h4 class="modal-title">Запрос на отмену отправлен</h4></div>'+
                        '<div class="modal-footer">'+
                        '<button class="btn" ng-click="$close()">Закрыть</button></div>'
                });
            });
        }

        function repeat(order)
        {
            repeatOrder(order).then(function(response) {
                if (0 == response.count) {
                    $uibModal.open({
                        animation: false,
                        template: '<div class="modal-header">'+
                        '<button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="$close()">'+
                        '<span aria-hidden="true">×</span></button>'+
                        '<h4 class="modal-title">Нет в наличии</h4></div>'+
                        '<div class="modal-body">Невозможно повторить заказ. Товаров нет в наличии!</div>'+
                        '<div class="modal-footer">'+
                        '<button class="btn" ng-click="$close()">Закрыть</button></div>'
                    });
                } else {
                    CompoBasket.loadStats().then(function (data) {
                        CompoBasket.stats = data
                    });
                    $uibModal.open({
                        animation: false,
                        template: '<div class="modal-header">'+
                        '<button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="$close()">'+
                        '<span aria-hidden="true">×</span></button>'+
                        '<h4 class="modal-title">Заказ добавлен в корзину</h4></div>'+
                        '<div class="modal-body">Добавлено товаров - '+ response.count +' шт.</div>'+
                        '<div class="modal-footer">'+
                        '<a href="/cart/" class="btn btn-success">В корзину</a>' +
                        '<button class="btn" ng-click="$close()">Закрыть</button></div>'
                    });
                }
            });
        }

        function getOrders()
        {
            return Orders.get(vm.filter).$promise;
        }

        function repeatOrder(order)
        {
            return Orders.repeat({id:order.id,action:'repeat'}).$promise;
        }

        function paginate(page) {
            vm.filter.page = page;

            if (vm.filter.page > 1) {
                paginatorStarted = true;
            }

            if (paginatorStarted) {
                vm.activate();
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.compob2b')
        .controller('PricePolitics', PricePolitics);

    PricePolitics.$inject = ['CompoApi','$timeout', 'manager'];

    /* @ngInject */
    function PricePolitics(CompoApi,$timeout, manager) {
        var vm = this,
            Api = CompoApi.getSource();
        vm.manager = manager;
        vm.politics = {};
        vm.alert = {
            show : false,
            class: '',
            text : ''
        };
        vm.save = save;

        activate();

        function activate() {
            getPolitics().then(function (response) {
                vm.politics = response;
            });
        }

        function save()
        {

            vm.politics.$save({method:'pricepolitics',id: vm.manager.id}).then(function(response) {
                if ('success' == response.state) {
                    vm.alert.class = 'color-green';
                    vm.alert.text = 'Данные сохранены';
                } else {
                    vm.alert.class = 'color-red';
                    vm.alert.text = 'Ошибка. Данные не сохранены';
                }

                vm.alert.show = true;
                $timeout(function () {
                    vm.alert.show = false;
                }, 3000);

            });
        }

        function getPolitics() {
            return Api.get({method:'pricepolitics',id:vm.manager.id}).$promise;
        }
    }
})();

(function() {
    'use strict';
    /** @ngInject */
    angular.module('app.compob2b').controller('ProductController', ProductController);
    ProductController.$inject = ['CompoApi', 'CompoBasket', 'CompoCompare'];

    /* @ngInject */
    function ProductController(CompoApi, CompoBasket, CompoCompare) {
        var v = this;
        var Product = CompoApi.getSource();

        v.sum = 0;
        v.count = 0;
        v.id = 0;
        v.contract = 0;
        v.basket = CompoBasket;
        v.discounts = [];
        v.specifiedPrice = 0;

        v.mainPicture = '/img/no_photo.gif';
        v.product = {
            id: 0,
            header: '',
            barcode: '',
            articul: '',
            volume: '',
            picture: 0,
            price: 0,
            picturetype: '',
            brand: [],
            collection: null,
            remains: []
        };

        v.addProductSet = addProductSet;

        v.recount = recount;
        v.setWish = setWish;
        v.setCompare = setCompare;

        v.inWish = false;
        v.inCompare = false;
        v.loaded = false;
        v.addRemains = addRemains;

        v.showWarehouse = showWarehouse;
        v.currentWarehouse = 'main'

        v.showBasketIsEmpty = showBasketIsEmpty;

        v.currentImageId = 'Main';
        v.setImage = setImage;
        v.updateImage = updateImage
        v.lastAddProductSet = [];

        angular.element('#modal_basket').on('show.bs.modal', function (event) {
            var message = angular.element('#modal_basket .message');

            if (v.currentWarehouse === 'wait') {
                message.html(
                    '<p>Обратите внимание, что товара нет в наличии на складе.</p>'
                    + '<p>Планируемая дата поступления указана в графе "Срок поставки"</p>'
                );
            } else if (v.currentWarehouse === 'soon') {
                message.html(
                    '<p>Обратите внимание, что товара нет в наличии на складе.</p>'
                    + '<p>Товар будет заказан у поставщика после оплаты.</p>'
                    + '<p>Время исполнения заказа указано в графе "Срок поставки."</p>'
                );
            } else if  (v.currentWarehouse === null) {
                var wms_ids = [];

                angular.forEach(v.lastAddProductSet, function(value, k) {
                    if (value === undefined) {
                        v.lastAddProductSet[k] = 0;
                    }

                    if (v.lastAddProductSet[k]) {
                        var t = k.split('-');
                        wms_ids.push(t[0]);
                    }
                });

                if (wms_ids.indexOf('52') >= 0 || wms_ids.indexOf('53') >= 0) {
                    message.append('<p>Обратите внимание, что части товара нет в наличии на складе.</p>');

                    if (wms_ids.indexOf('52') >= 0) {
                        message.append('<p>Дата поставки товара из поступления указана в графе "Срок поставки".</p>');
                    }

                    if (wms_ids.indexOf('53') >= 0) {
                        message.append('<p>Товар под заказ будет заказан у поставщика после оплаты.</p>');
                        message.append('<p>Время исполнения заказа указано в графе "Срок поставки".</p>');
                    }
                } else {
                    message.html('');
                }
            } else {
                message.html('');
            }

        });

        function setImage(img_id) {
            v.currentImageId = img_id;
            (_.debounce(updateImage, 300))();
        }

        function updateImage() {
            $('#img'+v.currentImageId).click();
        }

        function setWish(id, act) {
            var method = true == act ? 'setWish' : 'unsetWish';
            var params = {
                method: method,
                id: id
            };

            Product.put(params).$promise.then(function() {
                v.inWish = act;
            });
        }

        function setCompare(id, act) {
            var method = true == act ? 'addToCompare' : 'removeFromCompare';
            var params = {
                method: method,
                id: id
            };

            Product.put(params).$promise.then(function() {
                v.inCompare = act;
                CompoCompare.reload().then(function(data) {
                    CompoCompare.stats = data;
                });
            });
        }

        function unsetWish(id) {
            var params = {
                method: 'unsetWish',
                id: id
            };

            Product.put(params, function(response) {
                if (true == response) {
                    v.inwish = false;
                }
            });
        }

        function addProductSet(products) {
            CompoBasket.processProductSet(products)
                .then(function() {
                    v.lastAddProductSet = products;

                    console.log(products);

                    angular.element('#modal_basket').modal();

                    /*
                $timeout(function () {
                    angular.element('#modal_basket').modal('hide');
                }, 2500);
                */

                    CompoBasket.loadStats().then(function(data) {
                        CompoBasket.stats = data;
                    });
                })
                .catch(function(data, status) {
                    console.log(data + '-' + status);
                });
        }

        function showBasketIsEmpty() {
            angular.element('#modal_basket_alert').modal();
        }

        function addRemains(obj) {
            v.product.remains.push(obj);
        }

        function recount(wms_id, tovar_id, tovar_cid, specify) {
            var count = 0;
            var sum = 0;

            angular.forEach(v.productsCountSet, function(value, k) {
                if (value === undefined) {
                    v.productsCountSet[k] = 0;
                }

                var qnt = parseInt(value, 10) || 0;
                var price = v.product.remains[k].price;

                sum += qnt * price;
                count += qnt;

                v.count = count;
                v.sum = sum;

                if (specify) {
                    specifyPrice(k, tovar_id, wms_id);
                }
            });
        }

        function specifyPrice(key, tovar_id, wms_id) {
            var t = key.split('-');
            var tovar_cid = t[1]
            var current_value = null;
            var params = {
                method: 'specifyPrice',
                tovar_id: tovar_id,
                tovar_cid: tovar_cid
            };

            v.discounts.method === 'sum' ? (current_value = v.sum) : (current_value = v.count);

            Product.query(params).$promise.then(function(discounts) {
                angular.forEach(discounts, function(condition) {
                    countPrice(key, condition, current_value);
                });

                recount(wms_id, tovar_id, tovar_cid, false);
            });
        }

        function countPrice(key, condition, value) {
            if (value > parseInt(condition.discount_condition)) {
                v.product.remains[key].price = condition.pricecon;
            }
        }

        function showWarehouse(warehouseName) {
            v.currentWarehouse = warehouseName || null;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.compob2b')
        .controller('PurchasedGoods', PurchasedGoods);

    PurchasedGoods.$inject = ['CompoApi'];

    /* @ngInject */
    function PurchasedGoods(CompoApi) {
        /* jshint validthis: true */
        var vm = this,
            startDate = new Date,
            endDate = new Date,
            paginatorStarted = false,
            PurchasedGoods = CompoApi.getSource();

        startDate.setDate(startDate.getDate()-30);

        var ddStart = startDate.getDate();
        if (ddStart < 10) ddStart = '0' + ddStart;

        var mmStart = startDate.getMonth() + 1;
        if (mmStart < 10) mmStart = '0' + mmStart;

        var ddEnd = endDate.getDate();
        if (ddEnd < 10) ddEnd = '0' + ddEnd;

        var mmEnd = endDate.getMonth() + 1;
        if (mmEnd < 10) mmEnd = '0' + mmEnd;

        vm.count = 0;
        vm.contracts =[];
        vm.catalogs = [];
        vm.goods = [];
        vm.pagination = [];
        vm.perpage = '20';
        vm.preloader = true;
        vm.filter = {
            method: 'purchasedGoods',
            contract: '0',
            catalog: '0',
            report: 1,
            startDate: ddStart + '.' + mmStart + '.' + startDate.getFullYear(),
            endDate: ddEnd + '.' + mmEnd + '.' + endDate.getFullYear(),
            page: 1,
            perpage: vm.perpage
        };

        vm.reports = [
            {id: 1,header:'По товарам'},
            {id: 2,header:'Часто в заказах'},
            {id: 3,header:'Последнее в заказах'},
            {id: 4,header:'По сумме'}
        ];
        vm.activate = activate;
        vm.paginate = paginate;

        vm.activate();

        function activate()
        {
            vm.preloader = true;
            getGoods().then(function(response) {
                vm.goods = response.goods;
                vm.contracts = response.contracts;
                vm.catalogs = response.catalogs;
                vm.count = response.count;
                vm.pagination = response.pagination;
                vm.preloader = false;
            });
        }

        function getGoods()
        {
            return PurchasedGoods.put(vm.filter).$promise;
        }

        function paginate(page) {
            vm.filter.page = page;

            if (vm.filter.page > 1) {
                paginatorStarted = true;
            }

            if (paginatorStarted) {
                vm.activate();
            }
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.compob2b')
        .controller('RegionController', RegionController);

    RegionController.$inject = ['$scope', 'RegionApi'];

    /* @ngInject */
    function RegionController($scope, RegionApi) {
        var vm = this;

        vm.data = RegionApi.data;

        vm.getDeliveryChangeRegionHtml = function() {
            var html = $('<div class="delivery-change-region">');

            var btnYes = $('<span class="btn btn-light btn-delivery-region-yes">Да</span>');
            var btnNo = $('<span class="btn btn-light btn-delivery-region-no pull-right">Нет</span>');

            html.append(btnYes);
            html.append(btnNo);

            btnYes.click(function () {
                RegionApi.setConfirmed();

                $('#delivery-region-select-wrap').popover('hide');
            });

            btnNo.click(function () {
                RegionApi.setConfirmed();

                $('#delivery-region-select-wrap').popover('hide');

                $('.delivery-region-select-btn').click();
            });

            return html;
        };

        vm.init = function () {
            if (!vm.data.is_geo_location) {
                ymaps.ready(function () {
                    ymaps.geolocation.get({
                        provider: 'auto'
                    }).then(function (result) {
                        var region = result.geoObjects.get(0).getAdministrativeAreas()[0];
                        var city = result.geoObjects.get(0).getLocalities()[0];

                        RegionApi.changeRegion(region, city);
                        RegionApi.setGeoLocation();

                        $scope.$apply();

                        vm.displayConfirmDialog();
                    });
                });
            } else {
                vm.displayConfirmDialog();
            }

            $('#delivery-region-select-btn').popover({
                html: true,
                animation: false,
                trigger: 'manual',
                title: 'Выберите свой регион',
                placement: 'auto',
                container: 'body',
                //container: '#delivery-region-select-wrap',
                template: '<div class="popover delivery-region-select-popover" role="tooltip"><div class="arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>',

                content: function () {
                    return vm.getDeliveryRegionsListHtml;
                }
            });

            $('#delivery-region-select-btn').click(function () {
                $('#delivery-region-select-btn').popover('toggle');
            });
        };

        vm.getDeliveryRegionsListHtml = function () {
            var changeRegionCurrent = function () {
                $('#delivery_region_search_input').val($(this).data('city'));
                $('#delivery_region_search_input').suggestions().fixData();
            };

            var html = $('<div class="delivery-region-list">');

            var item = $('<div class="delivery-region-list-item">');

            item.data('city', vm.data.current_region.city);
            item.data('region', vm.data.current_region.region);

            item.addClass('delivery-region-list-item-current');

            var itemCurrent = $('<i class="fa fa-check-circle delivery-region-current-icon">');

            itemCurrent.appendTo(item);

            var itemName = $('<span class="delivery-region-list-item-name">');

            itemName.text(vm.data.current_region.city);

            itemName.appendTo(item);

            html.append(item);

            item.click(changeRegionCurrent);

            $.each(RegionApi.regions, function (key, value) {
                var item = $('<div class="delivery-region-list-item">');

                item.data('city', value.city);
                item.data('region', value.region);

                if (value.city === vm.data.current_region.city) {
                    return;
                }

                var itemName = $('<span class="delivery-region-list-item-name">');

                itemName.text(value.city);
                itemName.appendTo(item);

                html.append(item);

                item.click(changeRegionCurrent);
            });

            var searcCityWrap = $('<div class="delivery-region-search">');
            var searcCityLabel = $('<div class="delivery-region-search-label">');

            searcCityLabel.text('Поиск города');

            var searcCityIntput = $('<input id="delivery_region_search_input" name="delivery_region_search_input" type="text" />');

            searcCityIntput.val(vm.data.current_region.city);

            searcCityIntput.suggestions({
                token: '5f187c101ba7824eb82ebb4e6fd5c4085481487c',
                type: "ADDRESS",
                formatResult: function(value, currentValue, suggestion) {
                    var address = suggestion.data;
                    var addressValue = '';

                    if (address.region === address.city) {
                        addressValue = vm.join([
                            address.city,
                            address.settlement,
                            address.street_with_type,
                            vm.join([address.house_type, address.house,
                                address.block_type, address.block
                            ], " "),
                            vm.join([address.flat_type, address.flat], " ")
                        ]);
                    } else {
                        addressValue = vm.join([
                            address.region_with_type,
                            address.area_with_type,
                            address.city,
                            address.settlement,
                            address.street_with_type,
                            vm.join([address.house_type, address.house,
                                address.block_type, address.block
                            ], " "),
                            vm.join([address.flat_type, address.flat], " ")
                        ]);
                    }

                    suggestion.value = addressValue;

                    return addressValue;
                },

                formatSelected: function (suggestion) {
                    var address = suggestion.data;
                    var addressValue = '';

                    if (address.region === address.city) {
                        addressValue = vm.join([
                            address.city
                        ]);
                    } else {
                        addressValue = vm.join([
                            address.city
                        ]);
                    }

                    return addressValue;
                },
                bounds: "city",
                constraints: {
                    locations: { country: "Россия" }
                },
                geoLocation: true,
                onSelect: function (suggestion) {
                    $('#delivery-region-select-btn').popover('toggle');

                    RegionApi.changeRegion(suggestion.data.region, suggestion.data.city);

                    $scope.$apply();
                }
            });

            searcCityWrap.append(searcCityLabel);
            searcCityWrap.append(searcCityIntput);

            var resultHtml = $('<div>');

            resultHtml.append(html);
            resultHtml.append(searcCityWrap);

            return resultHtml;
        };

        vm.displayConfirmDialog = function () {
            var delivery_region_select_wrap = $('#delivery-region-select-wrap');

            if (!vm.data.is_confirmed) {
                delivery_region_select_wrap.popover({
                    container: '#delivery-region-select-wrap',
                    trigger: 'manual',
                    animation: false,
                    html: true,
                    title: '<b>Ваш населенный пункт ' + vm.data.current_region.city + '?</b>',
                    placement: 'auto top',
                    content: function () {
                        return vm.getDeliveryChangeRegionHtml;
                    }
                });

                delivery_region_select_wrap.popover('show');
            }
        };

        vm.join = function (arr) {
            var separator = arguments.length > 1 ? arguments[1] : ", ";
            return arr.filter(function (n) {
                return n;
            }).join(separator);
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('app.compob2b')
        .controller('RegistrationModal', RegistrationModal);

    RegistrationModal.$inject = ['CompoApi'];

    /* @ngInject */
    function RegistrationModal(CompoApi) {
        var vm = this,
            Registration = CompoApi.getSource();

        vm.registration = {};
        vm.save = save;
        vm.result = false;
        vm.submit_blocked = false;

        function save()
        {

            vm.submit_blocked = true;
            var params = {
                method: 'register',
                data: vm.registration
            };

            Registration.put(params).$promise.then(function (response) {

                vm.result = response;
                if (vm.result !== 'success') vm.submit_blocked = false;

            });
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.compob2b')
        .controller('Search', Search);

    Search.$inject = ['CompoApi','$uibModal'];

    /* @ngInject */
    function Search(CompoApi,$uibModal)
    {
        /* jshint validthis: true */
        var vm = this,
            SearchApi = CompoApi.getSearch();
        vm.results = [];
        vm.product = product;
        vm.search = search;
        vm.focusIn = focusIn;
        vm.contract = 0;

        function getProduct(id)
        {
            var url = '/ajax/getproduct/?id=' + id;

            $uibModal.open({
                size: 'lg',
                templateUrl: url,
                windowClass: 'modal fade popup-product',
                controller: 'ProductController',
                bindToController: true,
                controllerAs: 'v',
                resolve: {
                    id: function() { return id; },
                    contract: function() { return vm.contract; }
                }
            });

        }

        function focusIn(contract) {
            vm.contract = contract;
        }

        function product(selected) {
            getProduct(selected.originalObject.id);
        }

        function search(userInputString,timeoutPromise) {
            return SearchApi.get({keyword: userInputString,contract: vm.contract}, {timeout: timeoutPromise}).$promise;
        }

    }
})();
(function()
{
    'use strict';
    
    angular
        .module('app.compob2b')
        .controller('SimpleSearchController', SimpleSearchController);
    SimpleSearchController.$inject = ['CompoApi', 'CompoBasket'];
    /* @ngInject */ 
    function SimpleSearchController(CompoApi, CompoBasket)
    {
        var v = this;
        v.showHelp = false;
        v.result = [];
        v.change = change;
        v.addToBasket = addToBasket;
        v.basket = CompoBasket;

        function change()
        {
            var params = {
                method: 'search',
                'keyword': v.keyword
            };
            v.result = CompoApi.get(params);
            v.showHelp = true;
        }

        function addToBasket()
        {
            if (CompoBasket.qnt)
            {
                CompoBasket.processProductSet().then(function()
                {
                    CompoBasket.loadStats().then(function(data){CompoBasket.stats = data});
                    v.productSet = [];
                    angular.element('#cartDone').modal();
                }).catch(function(data, status)
                {
                    console.log(data + '-' + status);
                });
                v.showHelp = false;
            }
        }
    }
})();
(function () {
    'use strict';
    angular
        .module('app.compob2b.directives')
        .directive('compoPagination', ['$location', compoPagination]);
    /* @ngInject */
    function compoPagination($location) {
        return {
            restrict: 'E',
            scope: {
                'count': '=',
                'take': '=',
                'activate': '&',
                'maxSize': '=?',
                'hideArrows': '=?'
            },
            template: template,
            link: function(scope, element) {
                var activate = scope.activate();
                var queryPage = $location.search().page;
                var current = queryPage ? parseInt(queryPage) : 1;
                var pagesCount;

                activate(current, scope.take);

                scope.$watchGroup(['take', 'count', 'maxSize', 'hideArrows'], rebuild);
                scope.isCurrent = isCurrent;
                scope.isDisabled = isDisabled;
                scope.pages = [];
                scope.toPage = toPage;

                scope.$on('$locationChangeSuccess', locationChanged);

                function isCurrent(page) {
                    return page.value === current;
                }

                function isDisabled(page) {
                    return page.type === 'separator'
                        || (page.type === 'prev' && current === 1)
                        || (page.type === 'next' && current === pagesCount);
                }

                function toPage(page) {
                    if (page.value === current || page.type === 'separator') return;


                    if (page.type === 'page') {
                        current = page.value;
                    }
                    else if (page.type === 'prev') {
                        if (current > 1) current--;
                        else return;
                    }
                    else if (page.type === 'next') {
                        if (current < pagesCount) current++;
                        else return;
                    }

                    activate(current, scope.take);
                    rebuild();
                }

                function rebuild() {
                    var options = buildOptions();
                    var pages = calc(options);

                    if (!pages) {
                        scope.pages = [];
                        return;
                    }

                    pagesCount = pages.count;
                    scope.pages = generate(pages, options);
                    $location.search('page', current);
                }

                function locationChanged() {
                    var page = parseInt($location.search().page);
                    if (!page) return;

                    scope.toPage({ type: 'page', value: page });
                }

                function buildOptions() {
                    var options = {
                        count: scope.count,
                        take: scope.take,
                        maxSize: 11,
                        current: current,
                        hideArrows: scope.hideArrows
                    };

                    if (scope.maxSize) {
                        if (scope.maxSize < 7) options.maxSize = 7;
                        else options.maxSize = scope.maxSize;
                    }

                    return options;
                }

                function calc(options) {
                    var pages = { };

                    pages.count = Math.ceil(options.count / options.take);

                    if (!pages.count || pages.count === 1) return;

                    if (options.maxSize % 2 === 0) {
                        pages.cellsLeft = options.maxSize / 2 - 1;
                        pages.cellsRight = options.maxSize / 2;
                    }
                    else {
                        pages.cellsLeft = (options.maxSize - 1) / 2;
                        pages.cellsRight = (options.maxSize - 1) / 2;
                    }

                    if (!options.hideArrows) {
                        pages.cellsLeft--;
                        pages.cellsRight--;
                    }

                    if (options.current > pages.cellsLeft + 1) pages.cellsLeft--;
                    if (options.current > pages.cellsLeft + 1) pages.cellsLeft--;
                    if (options.current < pages.count - pages.cellsRight) pages.cellsRight--;
                    if (options.current < pages.count - pages.cellsRight) pages.cellsRight--;

                    pages.lo = options.current - pages.cellsLeft;
                    pages.hi = options.current + pages.cellsRight;

                    if (pages.lo < 1)
                    {
                        pages.hi += 1 - pages.lo;
                        pages.lo = 1;
                    }

                    if (pages.hi > pages.count)
                    {
                        pages.lo -= pages.hi - pages.count;
                        pages.hi = pages.count;
                    }

                    return pages;
                }

                function generate(pages, options) {
                    var list;

                    if (pages.count <= options.maxSize) list = generateFlat(pages);
                    else list = generateFull(pages);

                    if (!options.hideArrows) {
                        list.unshift({ type: 'prev', value: '<' });
                        list.push({ type: 'next', value: '>' });
                    }

                    return list;
                }

                function generateFlat(pages) {
                    var list = [];

                    for (var i = 1; i <= pages.count; i++) {
                        list.push({ type: 'page', value: i });
                    }

                    return list;
                }

                function generateFull(pages) {
                    var list = [];

                    if (pages.lo > 1) list.push({ type: 'page', value: 1 });
                    if (pages.lo > 2) list.push({ type: 'separator', value: '...' });

                    for (var i = pages.lo; i <= pages.hi ; i++)
                    {
                        if (i <= 0 || i > pages.count) continue;
                        list.push({ type: 'page', value: i })
                    }

                    if (pages.hi < pages.count - 1) {
                        list.push({ type: 'separator', value: '...' })
                    }

                    if (pages.hi < pages.count) {
                        list.push({ type: 'page', value: pages.count });
                    }

                    return list;
                }
            }
        }
    }

    function template() {
      /*
        return '<div class="compoPagination">'
            + '<div class="page"'
            + 'ng-repeat="page in pages"'
            + 'ng-class="{ \'active\': isCurrent(page), \'disabled\': isDisabled(page) }"'
            + 'ng-click="toPage(page)">'
            + '{{ page.value }}'
            + '</div>'
            + '</div>';
       */     
       return '<ul class="pagination"><li ng-repeat="page in pages" ng-class="{ \'active\': isCurrent(page), \'disabled\': isDisabled(page) }" ><a ng-click="toPage(page)" href="">{{ page.value }}</a></li></ul>';
    }
})();
(function () {
    'use strict';
    angular
        .module('app.compob2b.directives')
        .directive('fancy', fancy);

    /* @ngInject */
    function fancy() {
        var linker = function($scope,element,attr){
            if($scope.$last) {
                var target = jQuery("[rel='" + attr.rel + "']");
                if (!target) {
                    target = $(element);
                }
                setTimeout(function() {
                    target.fancybox({
                        hideOnOverlayClick:false,
                        hideOnContentClick:false,
                        enableEscapeButton:false,
                        showNavArrows:false,
                        onComplete: function(){
                            $timeout(function(){
                                $compile($("#fancybox-content"))($scope);
                                $scope.$apply();
                                $.fancybox.resize();
                            })
                        }

                    });
                }, 1);
            }
        };
        return {
            restrict: 'A',
            link: linker
        };
    }
})();
(function () {
    'use strict';
    angular
        .module('app.compob2b.directives')
        .directive('inputMask', inputMask);

    /* @ngInject */
    function inputMask() {
        return {
            restrict: 'A',
            link: function (scope, el, attrs) {
                $(el).mask("+7 (999) 999-99-99", {placeholder: "_"});
            }
        };
    }
})();

/**
 * @Author: Geoffrey Bauduin <bauduin.geo@gmail.com>
 */
(function () {
    'use strict';
    angular
        .module('app.compob2b.directives')
        .directive('ionRangeSlider', ionRangeSlider);

    ionRangeSlider.$inject = ['$timeout'];

    /* @ngInject */
    function ionRangeSlider($timeout) {

        return {
            restrict: "EA",
            scope: {
                min: "=",
                max: "=",
                from: "=",
                to: "=",
                disable: "=",
                type: "@",
                step: "@",
                minInterval: "@",
                maxInterval: "@",
                dragInterval: "@",
                values: "@",
                fromFixed: "@",
                fromMin: "@",
                fromMax: "@",
                fromShadow: "@",
                toFixed: "@",
                toMax: "@",
                toShadow: "@",
                prettifyEnabled: "@",
                prettifySeparator: "@",
                forceEdges: "@",
                keyboard: "@",
                keyboardStep: "@",
                grid: "@",
                gridMargin: "@",
                gridNum: "@",
                gridSnap: "@",
                hideMinMax: "@",
                hideFromTo: "@",
                prefix: "@",
                postfix: "@",
                maxPostfix: "@",
                decorateBoth: "@",
                valuesSeparator: "@",
                inputValuesSeparator: "@",
                prettify: "&",
                onChange: "&",
                onFinish: "&",
            },
            replace: true,
            link: function($scope, $element, attrs) {
                $element.ionRangeSlider({
                    min: $scope.min,
                    max: $scope.max,
                    from: $scope.from,
                    to: $scope.to,
                    disable: $scope.disable,
                    type: $scope.type,
                    step: $scope.step,
                    min_interval: $scope.minInterval,
                    max_interval: $scope.maxInterval,
                    drag_interval: $scope.dragInterval,
                    values: $scope.values,
                    from_fixed: $scope.fromFixed,
                    from_min: $scope.fromMin,
                    from_max: $scope.fromMax,
                    from_shadow: $scope.fromShadow,
                    to_fixed: $scope.toFixed,
                    to_max: $scope.toMax,
                    to_shadow: $scope.toShadow,
                    prettify_enabled: $scope.prettifyEnabled,
                    prettify_separator: $scope.prettifySeparator,
                    force_edges: $scope.forceEdges,
                    keyboard: $scope.keyboard,
                    keyboard_step: $scope.keyboardStep,
                    grid: $scope.grid,
                    grid_margin: $scope.gridMargin,
                    grid_num: $scope.gridNum,
                    grid_snap: $scope.gridSnap,
                    hide_min_max: $scope.hideMinMax,
                    hide_from_to: $scope.hideFromTo,
                    prefix: $scope.prefix,
                    postfix: $scope.postfix,
                    max_postfix: $scope.maxPostfix,
                    decorate_both: $scope.decorateBoth,
                    values_separator: $scope.valuesSeparator,
                    input_values_separator: $scope.inputValuesSeparator,

                    prettify: function(value) {
                        if (!attrs.prettify) {
                            return value;
                        }
                        return $scope.prettify({
                            value: value
                        });
                    },
                    onChange: function(a) {
                        $scope.$apply(function() {
                            $scope.from = a.from;
                            $scope.to = a.to;
                            $scope.onChange && $scope.onChange({
                                a: a
                            });
                        });
                    },
                    onFinish: function() {
                        $timeout(function() {
                            $scope.$apply($scope.onFinish);
                        });
                    },
                });
                var watchers = [];
                watchers.push($scope.$watch("min", function(value) {
                    $element.data("ionRangeSlider").update({
                        min: value
                    });
                }));
                watchers.push($scope.$watch('max', function(value) {
                    $element.data("ionRangeSlider").update({
                        max: value
                    });
                }));
                watchers.push($scope.$watch('from', function(value) {
                    var slider = $element.data("ionRangeSlider");
                    if (slider.old_from !== value) {
                        slider.update({
                            from: value
                        });
                    }
                }));
                watchers.push($scope.$watch('to', function(value) {
                    var slider = $element.data("ionRangeSlider");
                    if (slider.old_to !== value) {
                        slider.update({
                            to: value
                        });
                    }
                }));
                watchers.push($scope.$watch('disable', function(value) {
                    $element.data("ionRangeSlider").update({
                        disable: value
                    });
                }));
            }
        };

    }
})();

(function () {
    'use strict';
    angular
        .module('app.compob2b.directives')
        .directive('scrollPane', ['$timeout',scrollPane]);

    /* @ngInject */
    function scrollPane(timeout) {
        return {
                restrict: 'A',
                transclude: true,
                template: '<div class="scroll-pane"><div ng-transclude></div></div>',
                link: function($scope, $elem, $attrs) {
                  var config, fn, selector;
                  config = {};
                  if ($attrs.scrollConfig) {
                    config = $scope.$eval($attrs.scrollConfig);
                  }
                  selector = "#" + $attrs.id;
                  if ($attrs.scrollName) {
                    selector = "[scroll-name='" + $attrs.scrollName + "']";
                  }
                  fn = function() {
                    jQuery(selector).jScrollPane(config);
                    $scope.pane = jQuery(selector).data("jsp");
                    $scope.pane.scrollToBottom();
                    return $scope.pane;
                  };
                  if ($attrs.scrollTimeout) {
                    timeout(fn, $scope.$eval($attrs.scrollTimeout));
                  } else {
                    timeout(fn, 0);
                  }
                  $scope.$watch((function() {
                    return $attrs.scrollAlwaysTop;
                  }), function(newVal, oldVal) {
                    if (newVal && $scope.pane) {
                      $scope.pane.scrollToY(0);
                    }
                  });
                  return $scope.$on("reinit-pane", function(event, data) {
                    if (data.id === $attrs.id && $scope.pane) {
                      console.log("Reinit pane " + data.id);
                      return $scope.$apply(function() {
                        $scope.pane.destroy();
                        return fn();
                      });
                    }
                  });
                },
            replace: true
        };
    }
})();

(function () {
    'use strict';
    angular
        .module('app.compob2b.directives')
        .directive('selectOnClick', selectOnClick);

    selectOnClick.$inject = ['$window'];

    /* @ngInject */
    function selectOnClick($window) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                element.on('click', function () {
                    if (!$window.getSelection().toString()) {
                        //this.setSelectionRange(0, this.value.length)
                        this.select();
                    }
                });
                element.on('keyup', function () {
                    var pattern = /^0+[1-9]+$/;
                    if (pattern.test(this.value)) {
                        this.value = parseInt(this.value, 10);
                    }
                });
            }
        };
    }
})();
(function () {
    'use strict';
    angular
        .module('app.compob2b.directives')
        .directive('stringToNumber', stringToNumber);

    /* @ngInject */
    function stringToNumber() {
        return {
            require: 'ngModel',
            link: function (scope, element, attrs, ngModel) {
                ngModel.$parsers.push(function (value) {
                    return '' + value;
                });
                ngModel.$formatters.push(function (value) {
                    return parseFloat(value);
                });
            }
        };
    }
})();
(function () {
    'use strict';
    angular
        .module('app.compob2b.directives')
        .filter('price', Price);

    /* @ngInject */
    function Price() {
        return function (val, signs) {
            val = parseFloat(val).toFixed(signs);
            return formatMoney(val);
        }

        function formatMoney(amount) {
            try {

                var decimalCount = Math.abs(2), decimal = ".", thousands = " ";
                decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

                const negativeSign = amount < 0 ? "-" : "";

                var i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
                var j = (i.length > 3) ? i.length % 3 : 0;

                return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
            } catch (e) {
                console.log(e)
            }
        };
    }


})();
(function() {
    'use strict';

    angular
        .module('app.compob2b.core')
        .factory('CompoApi', CompoApi);

    CompoApi.$inject = ['$resource'];

    /* @ngInject */
    function CompoApi($resource) {
        var service = {
            getSearch: getSearch,
            getAccount: getAccount,
            getFilter: getFilter,
            getAddress: getAddress,
            getSource: getSource,
            getProduct: getProduct,
            getOrders: getOrders,
            getManager: getManager,
            getContragent: getContragent
        };

        return service;

        function getAccount()
        {
            return $resource('/api/account/:id');
        }

        function getManager()
        {
            return $resource('/api/manager/:id');
        }

        function getContragent()
        {
            return $resource('/api/contragent/:id');
        }

        function getAddress()
        {
            return $resource('/api/address/:id');
        }

        function getOrders()
        {
            return $resource('/api/order/:id',{id:'@id'},{
                cancel: {method: 'POST'},
                cancelRequest: {method: 'POST'},
                confirm: {method: 'POST'},
                repeat: {method: 'POST'},
                saveOrder: {method: 'POST'}
            });
        }


        function getProduct()
        {
            return $resource('/api/product/:id',{id:'@id'});
        }

        function getFilter()
        {
            return $resource('/api/:method/', {method:'@method'},{
                post: {method: 'POST'}
            });
        }

        function getSearch() {
            return $resource(
                '/api/search/', {keyword: '@keyword',contract:'@contract'}
            );
        }

        function getSource()
        {
            return $resource("/api/:method/:id/", {method:'@method',id:'@id'},
            {
                get: {method: 'GET'},
                put: {method: 'POST'},
                update: {method: 'POST'},
                del: {method: 'POST'}
            });
        }
    }

})();

(function () {
    'use strict';

    angular.module('app.compob2b.core')
        .factory("CompoBasket", CompoBasket);
    CompoBasket.$inject = ['CompoApi', '$q'];

    /* @ngInject */
    function CompoBasket(CompoApi, $q) {
        var HttpApi = CompoApi.getSource();
        return {
            stats: [],
            products: {},
            qnt: 0,
            region: 0,
            contract: 0,
            /* property shows if there already was ajax request for loading basket data ASAP loadStats() */
            resolved: 0,
            addProduct: function (id, qnt, wms) {
                //this.products[id] = qnt;
                return this.processBasket(id, qnt, wms, 'products');
            },

            processProductSet: function (products) {


                var params = {
                    method: 'processCountProductSet',
                    type: 'products',
                    products: products
                };

                var deferred = $q.defer();

                HttpApi.put(params, function (response) {
                    deferred.resolve(response)
                });
                this.clearQnt(this.products);
                return deferred.promise;


                // return CompoApi.put(params).$promise.then(this.clearQnt(this.products)  ) ;
            },

            checkPromo: function (promo) {

                var params = {
                    method: 'checkPromo',
                    promo: promo
                };

                return HttpApi.put(params).$promise;
            },
            checkProduct: function (id, qnt)   /* Виртуальный счетчик отмеченного количества товара для помещения в корзину, которые отмечены чекбоксами.  */ {
                if (!this.products[id]) {
                    this.products[id] = qnt;

                    this.qnt += this.getSum(qnt);
                }
                else {
                    var sum = this.getSum(qnt);
                    delete this.products[id];
                    this.qnt -= sum;
                }
                // console.log(this.products);
            },
            /* Возвращает заказанное количество товара по складам */
            getSum: function (qnt) {
                var sum = 0;
                angular.forEach(qnt, function (value) {
                    sum += value;
                });
                return sum;
            },
            clearBasket: function () {
                var params = {
                    method: 'clearBasket'
                };

                return HttpApi.get(params).$promise;

            },
            processBasket: function (id, qnt, wms, type) {
                this.processLoader(1);
                var params = {
                    method: 'processBasket',
                    id: id,
                    qnt: qnt,
                    wms: wms,
                    type: type
                };

                var deferred = $q.defer();
                HttpApi.update(params, function (response) {
                    deferred.resolve(response)
                });
                this.processLoader(0);
                return deferred.promise;

            },
            changeDeliveryMethod: function (id) {
                this.processLoader(1);
                var params = {
                    method: 'changeDeliveryMethod',
                    id: id
                };

                var deferred = $q.defer();
                HttpApi.update(params, function (response) {
                    deferred.resolve(response)
                });
                this.processLoader(0);
                return deferred.promise;
            },
            changeDeliveryPoint: function (id) {
                this.processLoader(1);
                var params = {
                    method: 'changeDeliveryPoint',
                    id: id
                };

                var deferred = $q.defer();
                HttpApi.update(params, function (response) {
                    deferred.resolve(response)
                });
                this.processLoader(0);
                return deferred.promise;
            },
            processBasketUpdate: function (id, qnt, wms, type) {
                this.processLoader(1);
                var params = {
                    method: 'processBasketUpdate',
                    id: id,
                    qnt: qnt,
                    wms: wms,
                    type: type
                };

                var deferred = $q.defer();
                HttpApi.update(params, function (response) {
                    deferred.resolve(response)
                });
                this.processLoader(0);
                return deferred.promise;

            },
            addToDraft: function (name) {
                var params = {
                    method: 'addToDraft',
                    header: name
                };

                var deferred = $q.defer();
                HttpApi.update(params, function (response) {
                    deferred.resolve(response)
                });
                return deferred.promise;
            },
            loadStats: function () {

                var params = {
                    method: 'getBasketData'
                };

                var deferred = $q.defer();

                HttpApi.get(params, function (response) {
                    deferred.resolve(response)
                });

                /*we did an ajax request from the one of controllers. */
                this.resolved = 1;

                return deferred.promise;

            },

            countProducts: function () {
                return this.stats.count.products;
            },
            clearQnt: function () {
                this.products = {};
                this.qnt = 0;
            },
            processLoader: function (state) {

                if (state)
                    angular.element('#dvLoading').fadeIn();
                else
                    angular.element('#dvLoading').fadeOut();
            },
            setContract: function (contract) {
                this.contract = contract;
            },
            setRegion: function (region) {
                this.region = region;
            }
        };
    }
})();

(function () {
    'use strict';

    angular.module('app.compob2b.core')
        .factory("CompoCompare", CompoCompare);
    CompoCompare.$inject = ['CompoApi', '$q'];

    /* @ngInject */
    function CompoCompare(CompoApi, $q) {
        var HttpApi = CompoApi.getSource();
        var self = this;
        return {
            stats: [],
            setCompare: function (id) {

                var method = 'compare';
                var params = {
                    method: method,
                    id: id
                };

                var deferred = $q.defer();

                HttpApi.put(params, function (response) {
                    deferred.resolve(response)
                });

                return deferred.promise;
            },

            reload: function () {
                var method = 'getCompare';
                var params = {
                    method: method
                };

                var deferred = $q.defer();

                HttpApi.get(params, function (response) {
                    deferred.resolve(response)
                });

                return deferred.promise;
            },

            clearCompare: function () {
                var params = {
                    method: 'clearCompare'
                };

                return HttpApi.get(params).$promise;

            }

        };
    }
})();
(function() {
    'use strict';

    angular
        .module('app.compob2b.core')
        .factory('RegionApi', RegionApi);

    RegionApi.$inject = ['$http'];

    /* @ngInject */
    function RegionApi($http) {
        var region_api = {
            data: {
                is_confirmed: false,
                is_geo_location: false,
                current_region: {
                    region: 'Московская',
                    city: 'Москва'
                }
            },
            regions: [
                {
                    "region": "Московская",
                    "city": "Москва"
                },
                {
                    "region": "Санкт-Петербург и область",
                    "city": "Санкт-Петербург"
                },
                {
                    "region": "Хакасия",
                    "city": "Абакан"
                },
                {
                    "region": "Магаданская обл.",
                    "city": "Анадырь"
                },
                {
                    "region": "Архангельская обл.",
                    "city": "Архангельск"
                },
                {
                    "region": "Астраханская обл.",
                    "city": "Астрахань"
                },
                {
                    "region": "Алтайский край",
                    "city": "Барнаул"
                },
                {
                    "region": "Белгородская обл.",
                    "city": "Белгород"
                },
                {
                    "region": "Еврейская обл.",
                    "city": "Биробиджан"
                },
                {
                    "region": "Алтайский край",
                    "city": "Благовещенск"
                },
                {
                    "region": "Брянская обл.",
                    "city": "Брянск"
                },
                {
                    "region": "Приморский край",
                    "city": "Владивосток"
                },
                {
                    "region": "Северная Осетия",
                    "city": "Владикавказ"
                },
                {
                    "region": "Владимирская обл.",
                    "city": "Владимир"
                },
                {
                    "region": "Волгоградская обл.",
                    "city": "Волгоград"
                },
                {
                    "region": "Вологодская обл.",
                    "city": "Вологда"
                },
                {
                    "region": "Воронежская обл.",
                    "city": "Воронеж"
                },
                {
                    "region": "Алтайский край",
                    "city": "Горно-Алтайск"
                },
                {
                    "region": "Чечено-Ингушетия",
                    "city": "Грозный"
                },
                {
                    "region": "Свердловская обл.",
                    "city": "Екатеринбург"
                },
                {
                    "region": "Ивановская обл.",
                    "city": "Иваново"
                },
                {
                    "region": "Удмуртия",
                    "city": "Ижевск"
                },
                {
                    "region": "Иркутская обл.",
                    "city": "Иркутск"
                },
                {
                    "region": "Марий Эл",
                    "city": "Йошкар-Ола"
                },
                {
                    "region": "Татарстан",
                    "city": "Казань"
                },
                {
                    "region": "Москва и Московская обл.",
                    "city": "Калининград"
                },
                {
                    "region": "Калужская обл.",
                    "city": "Калуга"
                },
                {
                    "region": "Кемеровская обл.",
                    "city": "Кемерово"
                },
                {
                    "region": "Кировская обл.",
                    "city": "Киров"
                },
                {
                    "region": "Костромская обл.",
                    "city": "Кострома"
                },
                {
                    "region": "Краснодарский край",
                    "city": "Краснодар"
                },
                {
                    "region": "Красноярский край",
                    "city": "Красноярск"
                },
                {
                    "region": "Курганская обл.",
                    "city": "Курган"
                },
                {
                    "region": "Курская обл.",
                    "city": "Курск"
                },
                {
                    "region": "Тува (Тувинская Респ.)",
                    "city": "Кызыл"
                },
                {
                    "region": "Липецкая обл.",
                    "city": "Липецк"
                },
                {
                    "region": "Магаданская обл.",
                    "city": "Магадан"
                },
                {
                    "region": "Адыгея",
                    "city": "Майкоп"
                },
                {
                    "region": "Дагестан",
                    "city": "Махачкала"
                },
                {
                    "region": "Мурманская обл.",
                    "city": "Мурманск"
                },
                {
                    "region": "Чечено-Ингушетия",
                    "city": "Назрань"
                },
                {
                    "region": "Кабардино-Балкария",
                    "city": "Нальчик"
                },
                {
                    "region": "Нижегородская (Горьковская)",
                    "city": "Нижний Новгород"
                },
                {
                    "region": "Новосибирская обл.",
                    "city": "Новосибирск"
                },
                {
                    "region": "Омская обл.",
                    "city": "Омск"
                },
                {
                    "region": "Орловская обл.",
                    "city": "Орел"
                },
                {
                    "region": "Оренбургская обл.",
                    "city": "Оренбург"
                },
                {
                    "region": "Пензенская обл.",
                    "city": "Пенза"
                },
                {
                    "region": "Пермская обл.",
                    "city": "Пермь"
                },
                {
                    "region": "Карелия",
                    "city": "Петрозаводск"
                },
                {
                    "region": "Камчатская обл.",
                    "city": "Петропавловск-Камчатский"
                },
                {
                    "region": "Псковская обл.",
                    "city": "Псков"
                },
                {
                    "region": "Ростовская обл.",
                    "city": "Ростов-на-Дону"
                },
                {
                    "region": "Рязанская обл.",
                    "city": "Рязань"
                },
                {
                    "region": "Самарская обл.",
                    "city": "Самара"
                },
                {
                    "region": "Мордовия",
                    "city": "Саранск"
                },
                {
                    "region": "Саратовская обл.",
                    "city": "Саратов"
                },
                {
                    "region": "Смоленская обл.",
                    "city": "Смоленск"
                },
                {
                    "region": "Ставропольский край",
                    "city": "Ставрополь"
                },
                {
                    "region": "Коми",
                    "city": "Сыктывкар"
                },
                {
                    "region": "Тамбовская обл.",
                    "city": "Тамбов"
                },
                {
                    "region": "Тверская обл.",
                    "city": "Тверь"
                },
                {
                    "region": "Томская обл.",
                    "city": "Томск"
                },
                {
                    "region": "Тульская обл.",
                    "city": "Тула"
                },
                {
                    "region": "Тюменская обл.",
                    "city": "Тюмень"
                },
                {
                    "region": "Бурятия",
                    "city": "Улан-Удэ"
                },
                {
                    "region": "Ульяновская обл.",
                    "city": "Ульяновск"
                },
                {
                    "region": "Башкортостан(Башкирия)",
                    "city": "Уфа"
                },
                {
                    "region": "Хабаровский край",
                    "city": "Хабаровск"
                },
                {
                    "region": "Чувашия",
                    "city": "Чебоксары"
                },
                {
                    "region": "Челябинская обл.",
                    "city": "Челябинск"
                },
                {
                    "region": "Ставропольский край",
                    "city": "Черкесск"
                },
                {
                    "region": "Читинская обл.",
                    "city": "Чита"
                },
                {
                    "region": "Калмыкия",
                    "city": "Элиста"
                },
                {
                    "region": "Сахалин",
                    "city": "Южно-Сахалинск"
                },
                {
                    "region": "Саха (Якутия)",
                    "city": "Якутск"
                },
                {
                    "region": "Ярославская обл.",
                    "city": "Ярославль"
                }
            ]
        };

        region_api.onChangeRegion = function () {

        };

        region_api.changeRegion = function (region, city) {
            region_api.data.current_region.region = region;
            region_api.data.current_region.city = city;

            region_api.onChangeRegion(region_api.data);

            $http.post(
                '/region/',
                {
                    action: 'changeRegion',
                    current_region: region_api.data.current_region
                }
            ).then(function (response) {

            });
        };

        region_api.setConfirmed = function () {
            region_api.data.is_confirmed = true;

            $http.post(
                '/region/',
                {
                    action: 'setConfirmed',
                }
            ).then(function (response) {

            });
        };

        region_api.setGeoLocation = function () {
            region_api.data.is_geo_location = true;

            $http.post(
                '/region/',
                {
                    action: 'setGeoLocation',
                }
            ).then(function (response) {

            });
        };
        return region_api;
    }

})();

(function () {
    'use strict';

    angular.module('app.compob2b')
        .factory("Store", Store);

    Store.$inject = ['CompoApi','$rootScope'];
    /* @ngInject */
    function Store(CompoApi,rootScope) {
        var Api = CompoApi.getSource();

        return {
            getData: getData,
            data:[],
            catalog:'147',
            setCatalog: function(id)
            {
                this.catalog = id;
                rootScope.$broadcast('store:catalog:change');
            },
            getCatalog: function()
            {
                return this.catalog;
            }
        };

        function getData() {
            return Api.get({method: 'initdata'}).$promise;
        }

    }
})();


$(function () {
    $(window).on('ajaxComplete', function() {
        setTimeout(function() {
            $(window).lazyLoadXT();
        }, 50);
    });

    var options = $.lazyLoadXT,
        bgAttr = options.bgAttr || 'data-bg';

    options.selector += ',[' + bgAttr + ']';

    $(document).on('lazyshow', function (e) {
        var $this = $(e.target);
        if( typeof( $this.attr(bgAttr) ) != 'undefined' ) {
            $this
                .css('background-image', "url('" + $this.attr(bgAttr) + "')")
                .removeAttr(bgAttr);
        }
    });

    $('.phone').mask("+7 (999) 999-99-99", {placeholder: "_"});
    $('#sorting').selectmenu({

        change: function (event, data) {
            var sort_by = $(this).val();
            var url = $(this).data('baseurl');
            var params = [];
            var keyword = window.location.search.match(/keyword=([^&]+)/);
            if (keyword) params.push('keyword=' + decodeURIComponent(keyword[1].replace(/<[^>]+>/gi, '')));
            if (sort_by != 'pop') params.push('sort_by=' + decodeURIComponent(sort_by));
            var show = window.location.search.match(/show=([^&]+)/);
            if (show) params.push('show=' + parseInt(show[1]));
            var view_as = window.location.search.match(/view_as=([^&]+)/);
            if (view_as) params.push('view_as=' + decodeURIComponent(view_as[1]));
            if (params.length) url += '?' + params.join('&');
            window.location = url;
        }

    });

    $('.btn-menu').on('click', function () {
        $('.mobilemenu').addClass('active');
        $('html').addClass('gmactive');
        return false;
    });
    $('.mobilemenu-close').on('click', function() {
        $('.mobilemenu').removeClass('active');
        $('html').removeClass('gmactive');
        return false;
    });

    $('.mobilemenu-catalog-link').on('click', function () {
        $('.mobile-catalog').addClass('active');
        $('html').addClass('gmactive');
        return false;
    });
    $('.mobile-catalog-back').on('click', function() {
        $('.mobile-catalog').removeClass('active');
        if ( !$('.mobilemenu').hasClass('active') ) {
            $('html').removeClass('gmactive');
        };
        return false;
    });

    $('.h-prpage-link').on('click', function () {
        if ( $(window).width() <=991 ) {
            $('.slmobile').addClass('active');
            $('html').addClass('gmactive');
            return false;
        };
    });
    $('.slmobile-close').on('click', function() {
        $('.slmobile').removeClass('active');
        $('html').removeClass('gmactive');
        return false;
    });

    $('.mbcatalog-menu-sub > a').on('click', function () {
        $(this).toggleClass('active');
        $(this).next('ul').slideToggle('fast');
        return false;
    });

    $('.dataselect').selectmenu({
        change: function () {
            $(this).trigger('change');
        }
    });

    $("#MyAddress").suggestions({
        token: "9390e279a62975362970b675a17f214b0e5af966",
        type: "ADDRESS"
    });

    if ($('.datepick').length) {
        $(".datepick").datepicker({
            dateFormat: 'dd.mm.yy',
            inline: true,
            language: 'ru',
            changeYear: true,
            changeMonth: true,
            beforeShowDay: $.datepicker.noWeekends,
            //beforeShowDay: function(date) {
            //    var day = date.getDay();
            //    return [(day != 0), ''];
            //},
            minDate: 1,
            maxDate: '+1w'
        });
    };
    if ($('.datepicker').length) {
        $(".datepicker").datepicker({
            dateFormat: 'dd.mm.yy',
            inline: true,
            language: 'ru',
            changeYear: true,
            changeMonth: true,
        });
    };
/*
    $('.l-category ul').each(function () {
        if ($(this).children('li').length < 5) {
            $(this).next('.link-more').hide()
        }
    })

    $('.l-category .link-more').on('click', function () {
        $(this).toggleClass('active')
        $(this).prev('ul').find('li:nth-child(n+5)').slideToggle(0)
        return false
    })
*/
    $(window).scroll(function () {
        if (this.pageYOffset > $('header').outerHeight(true)) {
            $('header').addClass('active')
        } else {
            $('header').removeClass('active')
        }
    }).trigger('scroll');

    $('.sl-goods-sale').slick({
        dots: true,
        infinite: false,
        speed: 700,
        slidesToShow: 6,
        slidesToScroll: 6,
        prevArrow: $('#prev00'),
        nextArrow: $('#next00'),
        responsive: [
            {
                breakpoint: 1921,
                settings: {
                    slidesToShow: 6,
                    slidesToScroll: 6,
                }
            },
            {
                breakpoint: 1441,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 5,
                }
            },
            {
                breakpoint: 1201,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4
                }
            },
            {
                breakpoint: 1001,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3
                }
            },
            {
                breakpoint: 750,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 641,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });

    $('.sl-goods-preorder').slick({
        dots: true,
        infinite: false,
        speed: 700,
        slidesToShow: 6,
        slidesToScroll: 6,
        prevArrow: $('#prev02'),
        nextArrow: $('#next02'),
        responsive: [
            {
                breakpoint: 1921,
                settings: {
                    slidesToShow: 6,
                    slidesToScroll: 6,
                }
            },
            {
                breakpoint: 1441,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 5,
                }
            },
            {
                breakpoint: 1201,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4
                }
            },
            {
                breakpoint: 1001,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3
                }
            },
            {
                breakpoint: 750,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 641,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });

    $('.sl-goods-new').slick({
        dots: true,
        infinite: false,
        speed: 700,
        slidesToShow: 6,
        slidesToScroll: 6,
        prevArrow: $('#prev01'),
        nextArrow: $('#next01'),
        responsive: [
            {
                breakpoint: 1921,
                settings: {
                    slidesToShow: 6,
                    slidesToScroll: 6,
                }
            },
            {
                breakpoint: 1441,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 5,
                }
            },
            {
                breakpoint: 1201,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4
                }
            },
            {
                breakpoint: 1001,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3
                }
            },
            {
                breakpoint: 750,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 641,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });

    $('.sl-goods-else').slick({
        dots: true,
        infinite: false,
        speed: 700,
        slidesToShow: 6,
        slidesToScroll: 6,
        prevArrow: $('#prev02'),
        nextArrow: $('#next02'),
        responsive: [
            {
                breakpoint: 1921,
                settings: {
                    slidesToShow: 6,
                    slidesToScroll: 6,
                }
            },
            {
                breakpoint: 1441,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 5,
                }
            },
            {
                breakpoint: 1201,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4
                }
            },
            {
                breakpoint: 1001,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3
                }
            },
            {
                breakpoint: 750,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 641,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });


    var responsive_related_products = [
        {
            breakpoint: 1921,
            settings: {
                slidesToShow: 5,
                slidesToScroll: 5,
            }
        },
        {
            breakpoint: 1441,
            settings: {
                slidesToShow: 5,
                slidesToScroll: 5,
            }
        },
        {
            breakpoint: 1201,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 4
            }
        },
        {
            breakpoint: 1001,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3
            }
        },
        {
            breakpoint: 750,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2
            }
        },
        {
            breakpoint: 641,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
    ];

    $('.sl-goods-related').slick({
        dots: true,
        infinite: false,
        speed: 700,
        slidesToShow: 6,
        slidesToScroll: 6,
        prevArrow: $('#prev00'),
        nextArrow: $('#next00'),
        responsive: responsive_related_products
    });

    $('.sl-goods-analogs').slick({
        dots: true,
        infinite: false,
        speed: 700,
        slidesToShow: 6,
        slidesToScroll: 6,
        prevArrow: $('#prev01'),
        nextArrow: $('#next01'),
        responsive: responsive_related_products
    });


    $('.pr-img-slider').slick({
        dots: false,
        arrows: false,
        infinite: true,
        speed: 500,
        fade: true,
        cssEase: 'linear'
    });

    $('.top-block-carousel').slick({
        autoplay: true,
        // autoplaySpeed: 500,
        // adaptiveHeight: true,
        dots: false,
        arrows: false,
        // infinite: true,
        // speed: 500,
    });
    $('.top-block-carousel .slick-list').addClass('h-100');
    $('.top-block-carousel .slick-track').addClass('h-100');
    $('.top-block-carousel .slick-slide div').addClass('h-100');

    $('.pr-img-preview-item a').on('click', function () {
        $(this).parent().addClass('active').siblings('div').removeClass('active')
        $('.pr-img-slider').slick('slickGoTo', $(this).parent().index())
        return false
    });
    $('.pr-img-slider').on('afterChange', function (event, slick, currentSlide, nextSlide) {
        $('.pr-img-preview-item').eq(currentSlide).addClass('active').siblings('div').removeClass('active')
    });


    $('.inp').focus(function () {
        $(this).parent('.inp-styled').addClass('focused')
    });

    $('.inp').blur(function () {
        if ($(this).val() == '') {
            $(this).parent('.inp-styled').removeClass('focused')
        }
    });

    $('.list-chs-more').each(function () {
        var num = $(this).prev('.list-chs').find('li').length - 6;
        if (num <= 0) {
            $(this).hide(0)
        }
        $(this).find('.ch-num').html('Еще ' + num)
        console.log('Еще ' + num)
    });

    $('.list-chs-more').on('click', function () {
        $(this).toggleClass('active')
        $(this).prev('.list-chs').toggleClass('active')
        return false
    });

    $('.sidemenu-podmenu-catalog .sidemenu-podmenu-a').on('click', function () {
        $(this).parent('li').toggleClass('active')
        $(this).next('.sidemenu-podmenu-sub').slideToggle('fast')
        return false
    });

    $('.sidemenu-linktoitems').on('click', function () {
        $(this).toggleClass('active')
        $('.sidemenu-hide').slideToggle('fast')
        return false
    });

    $('.pp-manu-catalog > a').on('click', function () {
        $(this).parent('li').toggleClass('active')
        return false
    });

    $('.h-btns-more').on('click', function () {
        $(this).parents('.history-item').toggleClass('active');
        $(this).parents('.history-item').find('.history-slide').slideToggle('fast');
        return false;
    });

    $('.compare-slider').slick({
        dots: false,
        infinite: false,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            }
        ]
    });

    if ($(window).width() > 767) {
        comapare992()
    } else {
        comaparemobile()
    };

    $(window).on("orientationchange", function () {
        if ($(window).width() > 767) {
            comapare992()
        } else {
            comaparemobile()
        }
    });

    $(window).resize(function () {
        if ($(window).width() > 767) {
            comapare992()
        } else {
            comaparemobile()
        }
    });

    $('.compare-side-head-link').on('click', function () {
        $(this).toggleClass('active')
        $('.compare-side-head-slide').slideToggle('fast')
        return false
    });

    $('.basket-num').each(function () {

        var button = $(this).find('a'),
            input = $(this).find('input');

        button.click(function () {
            var val = input.val(),
                max = input.data('max');

            if ($(this).index()) {
                if (val < max) {
                    input.val(++val).trigger('change');
                }
            } else {
                if (val > 0) {
                    input.val(--val).trigger('change');
                }
            }
            if (val > 0) {
                $(this).parents('.card-table-tr').addClass('card-table-checked');
            } else {
                $(this).parents('.card-table-tr').removeClass('card-table-checked');
            }
            return false;

        });

        input.focus(function () {
            $(this).select();
        });

        input.keyup(function () {
            var val = $(this).val(),
                max = $(this).data('max');
            if (!/^[1-9][0-9]*$/.test(val) || val > max) {
                val = 0;
                $(this).val(0).trigger('change');
            }

            if (0 < val) {
                $(this).parents('.card-table-tr').addClass('card-table-checked');
            } else {
                $(this).parents('.card-table-tr').removeClass('card-table-checked');
            }
        });

    });

    $('.wh-main.showmoreisp').on('click', function () {
        $(this).toggleClass('active');
        $('.wh-main.card-table').toggleClass('active');
        return false;
    });
    $('.wh-soon.showmoreisp').on('click', function () {
        $(this).toggleClass('active');
        $('.wh-soon.card-table').toggleClass('active');
        return false;
    });
    $('.wh-perspective.showmoreisp').on('click', function () {
        $(this).toggleClass('active');
        $('.wh-perspective.card-table').toggleClass('active');
        return false;
    });
    $('.wh-wait.showmoreisp').on('click', function () {
        $(this).toggleClass('active');
        $('.wh-wait.card-table').toggleClass('active');
        return false;
    });
    // /13.12.2018
});

function resetcompare() {
    $('.compare-side-item').each(function () {
        $(this).css({height: 'auto', top: 'auto'})
    });
    $('.compare-item').each(function () {
        $(this).css({height: 'auto', paddingTop: '10px'})
    });
}

function comapare992() {
    resetcompare()
    var numitems = $('.compare-side-item').length;
    for (var i = numitems; i >= 0; i--) {
        var mh = 0;
        var ms = parseInt($('.compare-side-item').eq(i).outerHeight(true));
        $('.compare-items-wrapper').each(function () {
            var h_block = parseInt($(this).find('.compare-item').eq(i).outerHeight(true))
            if (h_block > mh) {
                mh = h_block
            }
            if (ms > mh) {
                mh = ms
            }
            $(this).find('.compare-item').eq(i).css({height: mh, paddingTop: '10px'})
            $('.compare-side-item').eq(i).css({height: mh})
        })
    }
}

function comaparemobile() {
    resetcompare()
    var numitems = $('.compare-side-item').length;
    for (var i = numitems; i >= 0; i--) {
        var mh = 0;
        var ms = parseInt($('.compare-side-item').eq(i).outerHeight(true));
        $('.compare-items-wrapper').each(function () {
            var h_block = parseInt($(this).find('.compare-item').eq(i).outerHeight(true))
            if (h_block > mh) {
                mh = h_block
            }
            $(this).find('.compare-item').eq(i).css({height: mh + ms, paddingTop: ms + 10})
        })
    }

    $('.compare-side-item').each(function (index) {
        var i = index
        var postop = $('.compare-item').eq(index).position().top - 150;
        $(this).css({top: postop})
    })
}
